{
  "contentAutomation": {
    "seoTitle": "SEO-score",
    "seoTarget": "SEO-mål: mindst 7,5/10 og ingen tilbagegang. Kvalitets- og faktakrav gælder også.",
    "seoMissing": "Ikke SEO-vurderet endnu.",
    "seoStale": "Teksten er ændret siden vurderingen. Den tidligere SEO-score gælder ikke denne version.",
    "seoHint": "Automatisk publicering kræver mindst 7,5/10 og ingen tilbagegang. Scoren vurderer tekst og metadata; den er ikke en måling af placeringer, søgevolumen eller teknisk SEO.",
    "seoParts": { "SearchIntent": "Søgeord og søgeintention", "Metadata": "Meta-titel og beskrivelse", "Coverage": "Produktets informationsindhold", "Structure": "Struktur og læsbarhed" },
    "approve": "Godkend og publicér",
    "approveHint": "Med din godkendelse accepterer du det viste forslag og tager stilling til fundene ovenfor. Beskrivelse og SEO publiceres til Shopify og gemmes i Smibo. Din godkendelse logges, og originalen bevares.",
    "manuallyApproved": "Manuelt godkendt den {date}. Godkendelse og de oprindelige fund er gemt i historikken.",
    "recheck": "Kontrollér forslaget igen",
    "title": "Indhold og content-score",
    "intro": "Optimér eksisterende Shopify-produkter, gem originalerne, og publicér de ændringer, der består kontrollen.",
    "policy": "Beskrivelse og SEO opdateres automatisk. Eksisterende udsagn regnes som godkendt og må omformuleres uden stærkere løfter. Nye eller skærpede risikopåstande kræver gennemgang. Produkter udvælges blandt eksisterende Shopify-varer med kendte SKU'er og tekst. Synlighed ændres ikke.",
    "count": "Antal produkter", "start": "Optimér og publicér", "stop": "Stop de resterende",
    "history": "Vis historik og resultater", "hide": "Skjul historik", "running": "Kører", "ready": "Klar",
    "summary": "Seneste kørsel: {total} produkter · {published} publiceret · {exceptions} kræver opmærksomhed",
    "scoreHint": "Scoren er en AI-vurdering af teksten, ikke et løfte om placeringer eller salg. Faktatjek betyder overensstemmelse med kilden, ikke uafhængig dokumentation.",
    "product": "Produkt", "score": "Content-score", "status": "Status", "details": "Se ændringer",
    "before": "Før", "after": "Forslag / efter", "claims": "Påstande og kilder",
    "restore": "Gendan originalen i Smibo og Shopify", "reconcile": "Kontrollér publiceringsresultatet igen",
    "restoreHint": "Originalerne gemmes for både Smibo og Shopify. Gendannelse stopper, hvis nogen har redigeret indholdet siden publiceringen.",
    "parts": {"BuyerHelp":"Købshjælp / 30", "Accuracy":"Præcision / 25", "Readability":"Læsbarhed / 20", "SearchRelevance":"Søgerelevans / 15", "Specificity":"Produktspecifik værdi / 10"},
    "states": {"Queued":"I kø", "Evaluating":"Skriver og kontrollerer", "Rechecking":"Kontrollerer igen", "Publishing":"Publicerer", "Published":"Publiceret", "NeedsReview":"Kræver gennemgang", "Conflict":"Ændret kilde", "Failed":"Fejlet", "NeedsReconciliation":"Resultat skal kontrolleres", "RestoreQueued":"Gendannelse i kø", "Restoring":"Gendanner", "Restored":"Original gendannet", "Cancelled":"Stoppet"}
  },
  "nav": {
    "breadcrumb": "Sti",
    "opsSection": "Superadmin",
    "jobDashboard": "Joboversigt",
    "openMenu": "Åbn menu",
    "accountMenu": "Kontomenu",
    "signOut": "Log ud",
    "lightTheme": "Lyst tema",
    "darkTheme": "Mørkt tema",
    "dashboard": "Overblik",
    "packing": "Pakkeliste",
    "orders": "Ordrer",
    "orderDetail": "Ordre",
    "returns": "Returer",
    "customers": "Kunder",
    "subscriptions": "Abonnementer",
    "subscriptionDetail": "Abonnement",
    "subscriptionPlans": "Abonnementer til salg",
    "purchasing": "Indkøb",
    "purchaseOrders": "Indkøbsordrer",
    "purchaseOrderDetail": "Indkøbsordre",
    "products": "Produkter",
    "categories": "Kategorier",
    "brands": "Mærker",
    "variantTypes": "Varianttyper",
    "stockMovements": "Lagerjournal",
    "suppliers": "Leverandører",
    "supplierDetail": "Leverandør",
    "messages": "Beskeder",
    "messageTemplates": "Skabeloner",
    "shippingRules": "Fragtregler",
    "reports": "Rapporter",
    "channels": "Kanaler",
    "migration": "Dataflytning",
    "catalogue": "Leverandørkatalog",
    "campaigns": "Mailforslag",
    "members": "Brugere",
    "settings": "Indstillinger",
    "translations": "Egne ord",
    "carriers": "Fragtaftaler",
    "platform": "Drift",
    "integrations": "Opkoblinger",
    "group": {
      "sales": "Salg",
      "subscriptions": "Abonnementer",
      "stock": "Lager",
      "shipping": "Fragt",
      "setup": "Opsætning"
    }
  },
  "common": {
    "cancel": "Annullér",
    "nevermind": "Fortryd",
    "save": "Gem",
    "saveChanges": "Gem ændringer",
    "saveFailed": "Kunne ikke gemme",
    "create": "Opret",
    "confirm": "Bekræft",
    "delete": "Slet",
    "edit": "Redigér",
    "hide": "Skjul",
    "search": "Søg",
    "loading": "Henter…",
    "unexpectedError": "Uventet fejl.",
    "add": "Tilføj",
    "remove": "Fjern",
    "optional": "valgfrit",
    "optionalField": "Valgfrit",
    "none": "Ingen",
    "close": "Luk",
    "allStatuses": "Alle statusser",
    "actionFailed": "Handlingen mislykkedes",
    "units": "{count} stk.",
    "days": "{count} dage",
    "errors": {
      "tooManyRequests": "For mange forsøg lige nu. Vent et øjeblik, og prøv igen."
    }
  },
  "customers": {
    "title": "Kunder",
    "subtitle": "Hvem der har købt hvad. Oprettes automatisk, første gang en ordre kommer ind.",
    "searchPlaceholder": "Navn, e-mail, firma eller telefon",
    "blockedOnly": "Kun spærrede",
    "empty": "Ingen kunder fundet.",
    "loadFailed": "Kunne ikke hente kunder.",
    "loadOneFailed": "Kunne ikke hente kunden",
    "saved": "Kunden er gemt",
    "saveFailed": "Kunne ikke gemme",
    "columns": {
      "customer": "Kunde",
      "phone": "Telefon",
      "orders": "Ordrer",
      "spent": "Købt for",
      "latest": "Seneste"
    },
    "blocked": "Spærret",
    "blockedBanner": "Kunden er spærret.",
    "acceptsMarketing": "Har sagt ja til markedsføring",
    "blockCustomer": "Spær kunden",
    "stats": {
      "orders": "ordrer",
      "spent": "købt for",
      "average": "gennemsnit",
      "returns": "returer"
    },
    "customerSince": "Kunde siden {date}",
    "internalNote": "Intern note:",
    "sections": {
      "orders": "Ordrer",
      "subscriptions": "Abonnementer"
    },
    "noOrders": "Ingen ordrer endnu.",
    "lineCount": "{count} varelinjer",
    "nextRun": "næste {date}",
    "fields": {
      "name": "Navn",
      "company": "Firma",
      "phone": "Telefon",
      "vatNumber": "CVR",
      "internalNote": "Intern note",
      "blockedReason": "Årsag til spærring"
    },
    "merge": {
      "action": "Flet…",
      "title": "Flet kunde",
      "intro": "{name} ({email}) lægges ind under den kunde du vælger. Ordrehistorikken flytter med, og fremtidige bestillinger fra {email} havner samme sted.",
      "explainer": "Adressen bliver stående som en henvisning, så den ikke kan blive til en ny dublet. Intern note og spærring følger med; tilladelse til markedsføring gør ikke.",
      "searching": "Leder efter dubletter…",
      "candidates": "Ligner den samme person",
      "orSearch": "Eller søg efter kunden",
      "searchPlaceholder": "Navn, e-mail eller telefon",
      "choose": "Vælg en kunde",
      "confirm": "Flet ind i {name}",
      "done": "Flettet ind i {name}",
      "orderNoun": "{count} ordre | {count} ordrer",
      "subscriptionNoun": "{count} abonnement | {count} abonnementer",
      "movedBoth": "{orders} og {subscriptions} flyttet med.",
      "movedOrders": "{count} ordre flyttet med. | {count} ordrer flyttet med.",
      "movedSubscriptions": "{count} abonnement flyttet med. | {count} abonnementer flyttet med.",
      "movedNothing": "Der var intet at flytte.",
      "undoneBoth": "{orders} og {subscriptions} flyttet tilbage.",
      "undoneOrders": "{count} ordre flyttet tilbage. | {count} ordrer flyttet tilbage.",
      "undoneSubscriptions": "{count} abonnement flyttet tilbage. | {count} abonnementer flyttet tilbage.",
      "failed": "Kunne ikke flette",
      "orderCount": "{count} ordrer",
      "reasons": {
        "phone": "Samme telefonnummer",
        "vatNumber": "Samme CVR-nummer",
        "company": "Samme firmanavn",
        "name": "Samme navn"
      },
      "mergedBannerTitle": "Denne adresse er flettet.",
      "mergedBanner": "Ordrer og fremtidige bestillinger fra {email} hører nu under {name}.",
      "undo": "Fortryd fletningen",
      "undone": "Fletningen er fortrudt",
      "undoFailed": "Kunne ikke fortryde",
      "errors": {
        "intoSelf": "En kunde kan ikke flettes ind i sig selv.",
        "targetNotFound": "Den valgte kunde findes ikke.",
        "alreadyMerged": "Kunden er allerede flettet ind i en anden kunde.",
        "targetIsRedirect": "Den valgte kunde er selv flettet væk. Vælg den kunde der står tilbage.",
        "undoNotMerged": "Kunden er ikke flettet.",
        "undoNoRecord": "Der er ingen registrering af denne fletning, så den kan ikke fortrydes automatisk.",
        "undoSurvivorMerged": "Den kunde der stod tilbage er selv blevet flettet siden. Fortryd den seneste fletning først.",
        "undoSurvivorMissing": "Den kunde der stod tilbage findes ikke."
      },
      "notes": {
        "blockCarried": "Overført ved fletning.",
        "blockSurvivedUndo": "[Spærring stammer fra en fletning der siden er fortrudt]",
        "mergedFrom": "Overført ved fletning."
      }
    },
    "tabs": {
      "products": "Produkter",
      "categories": "Kategorier",
      "imports": "Indlæsninger"
    },
    "status": {
      "New": "Ny",
      "Published": "I shoppen",
      "Rejected": "Fravalgt"
    },
    "errors": {
      "notFound": "Kunden findes ikke.",
      "blockedReasonRequired": "Angiv en årsag, når en kunde spærres.",
      "noVatNumber": "Kunden har ikke noget momsnummer at slå op."
    },
    "vat": {
      "verify": "Slå op i VIES",
      "verifyFailed": "Opslaget mislykkedes",
      "checkedAt": "Slået op {date}",
      "receipt": "Kvittering {number}",
      "noReceipt": "Ingen kvittering — udfyld shoppens eget momsnummer under Moms for at få en.",
      "stale": "Opslaget er mere end et døgn gammelt.",
      "status": {
        "Unchecked": "Ikke slået op",
        "Valid": "Registreret",
        "Invalid": "Ikke registreret",
        "Unavailable": "Registret svarede ikke"
      },
      "lookUp": "Slå op",
      "registeredAddress": "Registreret adresse"
    }
  },
  "settings": {
    "errors": {
      "senderEmailInvalid": "Afsenderadressen ser ikke ud til at være en e-mailadresse."
    },
    "vat": {
      "title": "Moms",
      "intro": "Bruges til de beløb smibo selv beregner — abonnementstræk og manuelt indtastede linjer. Beløb der kommer fra en checkout beholder den sats, checkouten opkrævede.",
      "loadFailed": "Momsopsætningen kunne ikke hentes.",
      "saved": "Momsopsætningen er gemt",
      "homeCountry": "Shoppens land",
      "homeCountryHelp": "Afgør hvad der er indenlandsk salg og hvad der er eksport. Tomt læses som Danmark.",
      "defaultRate": "Shoppens egen sats",
      "defaultRateHelp": "Som en brøkdel: 0,25 for 25 %. Tomt læses som den danske standardsats.",
      "ossTitle": "Satser ved fjernsalg (OSS)",
      "ossHelp": "Kun nødvendigt når shoppen er OSS-registreret. Et land der ikke står her, opkræves med shoppens egen sats — hvilket er rigtigt indtil I registrerer jer, og forkert bagefter.",
      "addCountry": "Tilføj land",
      "save": "Gem moms",
      "ownVatNumber": "Shoppens eget momsnummer",
      "ownVatNumberHelp": "Sendes med når I slår en kundes momsnummer op. VIES udsteder kun en kvittering, når den ved hvem der spørger — og kvitteringen er det, der gør opslaget til bevis.",
      "ownVatNumberPlaceholder": "DK12345678"
    },
    "language": {
      "title": "Sprog",
      "intro": "Koden er engelsk; skærmene taler det sprog I vælger. Arbejdsområdets sprog gælder også de sider jeres kunder ser — tilmelding og abonnementsportal — hvor ingen er logget ind.",
      "workspace": "Arbejdsområdets sprog",
      "mine": "Mit sprog",
      "followWorkspace": "Følg arbejdsområdet",
      "saved": "Sproget er gemt"
    },
    "openJobDashboard": "Åbn joboversigten",
    "twoFactorTitle": "Kode på mail ved login",
    "twoFactorBody": "Når den er slået til, sender vi en kode til din mail, hver gang du logger ind på en ny computer. Du kan bede os om ikke at spørge igen på den computer, du sidder ved.",
    "twoFactorOn": "Kode på mail er slået til",
    "twoFactorOff": "Kode på mail er slået fra",
    "twoFactorFailed": "Indstillingen kunne ikke gemmes."
  },
  "vat": {
    "errors": {
      "rateMustBeFraction": "Angiv satsen som en brøkdel: 0,25 for 25 %.",
      "countryCodeInvalid": "Landekoden skal være på to bogstaver, fx DK.",
      "countryRateInvalid": "Satsen skal være en brøkdel mellem 0 og 1."
    }
  },
  "signUp": {
    "notFoundTitle": "Siden findes ikke",
    "notFoundBody": "Linket er enten forkert eller ikke længere aktivt. Kontakt butikken, hvis du mener det er en fejl.",
    "loadFailed": "Siden kunne ikke hentes. Prøv igen om lidt.",
    "everyMonth": "Leveres hver måned",
    "everyNMonths": "Leveres hver {count}. måned",
    "delivery": "Levering",
    "perDelivery": "Pr. levering",
    "name": "Navn",
    "email": "E-mail",
    "phone": "Telefon",
    "address": "Adresse",
    "postalCode": "Postnr.",
    "city": "By",
    "note": "Besked til butikken",
    "beforeSubmit": "Vi sender dig en e-mail, du skal bekræfte — der oprettes ingenting før da, og der trækkes ingen penge. Første levering sendes tidligst {date}, og du kan afmelde når som helst.",
    "submit": "Tilmeld",
    "checkInboxTitle": "Tjek din indbakke",
    "checkInboxBody": "Vi har sendt en e-mail til {email}. Klik på linket i den, så er du tilmeldt.",
    "nothingCreated": "Der er ikke oprettet noget endnu, og der trækkes ingen penge. Vi opretter først abonnementet, når du har bekræftet, at adressen er din.",
    "spamHint": "Kan du ikke finde mailen, så kig i spamfilteret. Linket virker i syv dage.",
    "errors": {
      "emailInvalid": "Angiv en gyldig e-mailadresse.",
      "nameRequired": "Angiv et navn.",
      "addressRequired": "Angiv adresse og postnummer.",
      "planUnavailable": "Abonnementet kan ikke tegnes lige nu.",
      "cannotComplete": "Tilmeldingen kunne ikke gennemføres. Kontakt os, så hjælper vi.",
      "failed": "Tilmeldingen kunne ikke gennemføres. Prøv igen om lidt."
    },
    "notes": {
      "signedUpOnline": "Tegnet via hjemmesiden."
    }
  },
  "returns": {
    "title": "Returer",
    "subtitle": "Varer på vej tilbage, hvad der kom, og hvad kunden har fået igen.",
    "empty": "Ingen returer endnu.",
    "loadFailed": "Kunne ikke hente returer.",
    "searchPlaceholder": "Returnr., ordrenr. eller e-mail",
    "orderPrefix": "ordre",
    "reasonColumn": "Årsag",
    "amountColumn": "Beløb",
    "announcedQuantity": "anmeldt {count} stk. à",
    "restockable": "Kan sælges igen",
    "backInStock": "{count} på lager igen",
    "shrinkageNote": "Forskellen mellem modtaget og \"kan sælges igen\" bogføres som svind, så tabet er synligt i lagerjournalen.",
    "refundAmount": "Beløb der betales tilbage",
    "goodsValue": "Varerne er {amount}.",
    "postReceived": "Bogfør modtaget",
    "saveAmount": "Gem beløb",
    "refund": "Refundér",
    "refundWithAmount": "Refundér {amount}",
    "received": "Varerne er bogført ind",
    "amountSaved": "Beløbet er gemt",
    "refunded": "Beløbet er refunderet",
    "customerColumn": "Kunde",
    "announcedColumn": "Anmeldt",
    "failed": "Fejlede",
    "receivedLabel": "Modtaget",
    "receivedCount": "{count} modtaget",
    "refundSection": "Refundering",
    "refundConfirm": "{amount} betales tilbage til kunden. Det kan ikke fortrydes herfra.",
    "captured": "Ordren har hævet {amount}.",
    "status": {
      "Announced": "Anmeldt",
      "Received": "Modtaget",
      "Completed": "Refunderet",
      "Cancelled": "Annulleret"
    },
    "reason": {
      "Regret": "Fortrudt",
      "WrongSize": "Forkert størrelse",
      "Defective": "Defekt",
      "WrongItemSent": "Forkert vare sendt",
      "DamagedInTransit": "Beskadiget under transport",
      "NotDelivered": "Ikke modtaget",
      "Other": "Andet"
    },
    "numberColumn": "Retur"
  },
  "stock": {
    "title": "Lagerjournal",
    "subtitle": "Hver eneste ændring af det fysiske lager, med årsag og saldo bagefter.",
    "empty": "Ingen bevægelser endnu.",
    "allReasons": "Alle årsager",
    "loadFailed": "Kunne ikke hente lagerjournalen.",
    "searchPlaceholder": "Varenr. eller reference",
    "timeColumn": "Tidspunkt",
    "productColumn": "Vare",
    "balanceColumn": "Beholdning",
    "reasonColumn": "Årsag",
    "changeColumn": "Ændring",
    "causeColumn": "Årsagen til",
    "reason": {
      "Dispatch": "Afsendt",
      "GoodsReceipt": "Varemodtagelse",
      "Adjustment": "Regulering",
      "Return": "Retur",
      "Shrinkage": "Svind"
    }
  },
  "messages": {
    "title": "Beskeder",
    "subtitle": "Alt hvad systemet har besluttet at sende — også det der ikke blev sendt.",
    "loadFailed": "Kunne ikke hente beskeder.",
    "dispatchNow": "Send nu",
    "dispatched": "{count} besked sendt | {count} beskeder sendt",
    "dispatchFailed": "Afsendelse mislykkedes",
    "requeued": "Lagt i kø igen",
    "requeue": "Læg i kø igen",
    "retryFailed": "Kunne ikke sende igen",
    "searchPlaceholder": "Modtager, emne eller reference",
    "empty": "Ingen beskeder endnu.",
    "noSenderTitle": "Der er ingen mailudbyder tilsluttet.",
    "noSenderBody": "Beskeder markeres som sendt og skrives i loggen, men når ikke frem til modtageren.",
    "noSenderAddress": "Der er ikke angivet en afsenderadresse, så alle beskeder undertrykkes.",
    "toSettings": "Gå til opsætning",
    "countSent": "{count} sendt",
    "countPending": "{count} afventer",
    "countRetrying": "{count} prøver igen",
    "countFailed": "{count} fejlet",
    "countSuppressed": "{count} ikke sendt",
    "attempts": "{count} forsøg",
    "viewMessage": "Se beskeden",
    "sendAgain": "Send igen",
    "toRecipient": "Til {email}",
    "columns": {
      "recipient": "Modtager",
      "message": "Besked"
    },
    "status": {
      "Pending": "Afventer",
      "Sent": "Sendt",
      "Retrying": "Prøver igen",
      "Failed": "Fejlet",
      "Suppressed": "Ikke sendt"
    }
  },
  "messageTemplates": {
    "title": "Beskedopsætning",
    "subtitle": "Afsender, support og teksterne kunderne modtager. Alle skabeloner har en standardtekst — I ændrer kun dem, I vil have jeres egne ord i.",
    "back": "Tilbage til beskeder",
    "loadFailed": "Kunne ikke hente opsætningen.",
    "settingsSaved": "Indstillingerne er gemt",
    "saveSettings": "Gem indstillinger",
    "templateSaved": "Skabelonen er gemt",
    "previewFailed": "Kunne ikke vise forhåndsvisning",
    "preview": "Forhåndsvis",
    "senderMissing": "Uden en afsenderadresse bliver alle beskeder undertrykt. Udfyld feltet nedenfor.",
    "senderSection": "Afsender og kontakt",
    "senderNamePlaceholder": "fx Happy Horse",
    "currencyHint": "Hvad I køber, sælger og rapporterer i. Kostpriser gemmes i denne valuta, og kostpriser sendes kun til en shop der bruger den samme.",
    "whenSection": "Hvornår der skrives",
    "noticeDaysHint": "0 slår varslet fra.",
    "backorderDaysHint": "Kortere forsinkelser er ikke værd at bekymre kunden med.",
    "notificationsEnabled": "Send beskeder til kunder",
    "panelsSection": "Paneler på Overblik",
    "panelsHint": "Vælg hvad forsiden viser. Rækkefølgen er den, I klikker dem til i. Ingen valgte giver standardopsætningen.",
    "customised": "Tilpasset",
    "switchedOff": "Slået fra",
    "unknownTag": "Ukendt: {names}",
    "unknownVariables": "Ukendte variabler: {names}",
    "resetTitle": "Nulstil skabelon",
    "resetBody": "\"{name}\" går tilbage til standardteksten. Jeres egen tekst slettes.",
    "reset": "Nulstil",
    "resetToDefault": "Nulstil til standardtekst",
    "resetDone": "Standardteksten er gendannet",
    "resetFailed": "Kunne ikke nulstille",
    "bodyLabel": "Tekst",
    "availableVariables": "Tilgængelige variabler",
    "variablesHint": "Klik for at indsætte. Ukendte variabler bliver til tom tekst.",
    "sendThis": "Send denne besked",
    "fields": {
      "senderName": "Afsendernavn",
      "senderEmail": "Afsenderadresse",
      "replyTo": "Svar-til",
      "supportEmail": "Support-e-mail",
      "supportPhone": "Supporttelefon",
      "shopUrl": "Shoppens adresse",
      "currency": "Valuta",
      "noticeDays": "Varsel før abonnementslevering (dage)",
      "backorderDays": "Restordre nævnes fra (dage)"
    },
    "template": {
      "order": {
        "shipped": {
          "name": "Ordre afsendt",
          "description": "Sendes når en ordre pakkes og afsendes."
        },
        "ready-for-pickup": {
          "name": "Klar til afhentning",
          "description": "Sendes når en click and collect-ordre er pakket og står klar i butikken."
        },
        "backordered": {
          "name": "Vare i restordre",
          "description": "Sendes når en eller flere varer på en ordre venter på levering fra leverandøren."
        },
        "cancelled": {
          "name": "Ordre annulleret",
          "description": "Sendes når en ordre annulleres."
        }
      },
      "subscription": {
        "delivered": {
          "name": "Abonnement afsendt",
          "description": "Sendes når et abonnement er trukket og pakken er på vej."
        },
        "payment-failed": {
          "name": "Betaling mislykkedes",
          "description": "Sendes når et abonnement ikke kunne trækkes. Beder kunden om at forny kortet."
        },
        "card-expiring": {
          "name": "Kort udløber snart",
          "description": "Sendes før et betalingskort udløber, så trækket ikke fejler."
        },
        "confirm-sign-up": {
          "name": "Bekræft tilmelding",
          "description": "Sendes når nogen udfylder tilmeldingsformularen. Intet oprettes før linket er klikket."
        },
        "signed-up": {
          "name": "Tilmelding modtaget",
          "description": "Sendes når nogen tegner et abonnement på hjemmesiden. Abonnementet er ikke aktivt endnu."
        },
        "cancelled": {
          "name": "Abonnement afsluttet",
          "description": "Sendes når et abonnement afsluttes."
        }
      },
      "purchasing": {
        "order-to-supplier": {
          "name": "Bestilling til leverandør",
          "description": "Sendes til leverandøren, når en indkøbsordre markeres som bestilt."
        }
      },
      "account": {
        "welcome": {
          "name": "Velkommen",
          "description": "Sendes til ejeren, kort efter et arbejdsområde er oprettet. Indeholder linket, der bekræfter e-mailadressen."
        },
        "confirm-email": {
          "name": "Bekræft e-mailadresse",
          "description": "Sendes, når nogen beder om bekræftelseslinket igen. Kan ikke slås fra — den er vejen ind i kontoen."
        },
        "password-reset": {
          "name": "Nulstil adgangskode",
          "description": "Sendes, når nogen har glemt sin adgangskode. Kan ikke slås fra — den er vejen ind i kontoen."
        },
        "invitation": {
          "name": "Invitation til arbejdsområdet",
          "description": "Sendes når en administrator opretter en ny bruger. Indeholder linket, hvor de vælger deres adgangskode. Kan ikke slås fra — den er vejen ind i kontoen."
        },
        "two-factor-code": {
          "name": "Kode ved login",
          "description": "Sendes når nogen med koden slået til logger ind. Afsendes med det samme frem for at vente på beskedkørslen, og kan ikke slås fra."
        }
      }
    }
  },
  "channels": {
    "title": "Kanaler",
    "subtitle": "Webshops der sender ordrer til smibo. Adgangstokens gemmes krypteret og vises aldrig igen.",
    "loadFailed": "Kunne ikke hente forbindelser.",
    "empty": "Der er ingen kanaler endnu. Ordrer kan indtil videre kun komme fra abonnementer.",
    "connect": "Tilslut shop",
    "connectAction": "Tilslut",
    "editConnection": "Redigér forbindelse",
    "saved": "Forbindelsen er gemt",
    "dandomainMigrationOnly": "Dandomain (kun migrering)",
    "noShopAddress": "Ingen butiksadresse",
    "lastSynced": "sidst synkroniseret {time}",
    "readUpTo": "læst frem til {time}",
    "test": "Test",
    "testWorks": "Forbindelsen virker",
    "testFailed": "Forbindelsen fejlede",
    "fetchOrders": "Hent ordrer",
    "syncDone": "Synkronisering færdig",
    "syncSummary": "{seen} set · {created} nye · {updated} opdateret · {errors} fejl",
    "runSummary": "{seen} set · {created} nye · {updated} opdateret",
    "pushCostPrices": "Send kostpriser",
    "retryRejected": "Prøv også dem shoppen afviste",
    "pushed": "{count} sendt",
    "pushSkipped": "{count} findes ikke i shoppen",
    "pushFailedCount": "{count} fejlede — prøves igen i nat",
    "allAlreadyPushed": "Alle kostpriser er allerede sendt",
    "costPricesPushed": "Kostpriser sendt",
    "pushFailed": "Kunne ikke sende kostpriser",
    "readiness": {
      "button": "Ordreberedskab",
      "title": "Shopify-ordreberedskab",
      "loading": "Kontrollerer hele ordrevejen …",
      "ready": "Platformen er klar til automatisk at modtage Shopify-ordrer.",
      "notReady": "Manuel ordrehentning kan muligvis testes, men automatisk levering mangler stadig et eller flere trin.",
      "provision": "Opsæt ordre-webhooks",
      "provisioned": "Shopify-webhooks er opsat",
      "provisionConfirmTitle": "Opsæt ordre-webhooks i Shopify?",
      "provisionConfirmMessage": "Platformen opretter eller opdaterer webhooks for nye, ændrede, annullerede og betalte ordrer samt refusioner og ordretransaktioner. Eksisterende abonnementer fra andre apps berøres ikke.",
      "states": {
        "ready": "Klar",
        "warning": "Bemærk",
        "blocked": "Mangler"
      }
    },
    "storefront": {
      "button": "Collections og menu",
      "title": "Shopify-butiksstruktur",
      "loading": "Bygger forhåndsvisning …",
      "intro": "Smibo omsætter den aktive Dandomain-struktur til automatiske Shopify-collections og en fast, overskuelig hovedmenu i højst tre niveauer.",
      "collections": "collections i alt",
      "catalog": "varekategorier",
      "brands": "brands",
      "special": "særlige collections",
      "menuHeading": "Fast hovedmenu",
      "submenuCount": "{count} underpunkter",
      "rerunHint": "Synkroniseringen kan køres igen. Smibo genfinder collections via kategori-id og opdaterer kun dem, hvis planen har ændret sig.",
      "sync": "Synkronisér til Shopify",
      "confirmTitle": "Erstat Shopifys hovedmenu?",
      "confirmMessage": "Der oprettes eller opdateres {count} collections, de udgives på Online Store, og Shopifys nuværende hovedmenu erstattes med den viste struktur.",
      "done": "Butiksstrukturen er synkroniseret",
      "doneDetail": "{created} oprettet · {updated} opdateret · {reused} genbrugt · {menu} menupunkter"
    },
    "productMigration": {
      "button": "Produkter til Shopify",
      "title": "Produkter til Shopify",
      "loading": "Gennemgår produktkataloget …",
      "intro": "Smibo foreslår en lille, repræsentativ pilot blandt aktive lagervarer. To pladser reserveres til de største egnede variantfamilier, så variantstrukturen bliver testet ordentligt.",
      "relevant": "aktive med lager, salg eller køb uden lager",
      "ready": "klar til overførsel",
      "waveOne": "klar og på lager",
      "needsWork": "kræver rettelser",
      "history": "Salgstallene dækker den importerede ordrehistorik fra {from} til {to}.",
      "pilotHeading": "Foreslået pilot",
      "pilotHint": "Du kan fravælge varer. En ændring i udvalget kræver altid en ny testkørsel.",
      "selection": "{products} varer · {variants} aktive varianter",
      "variantCount": "{count} varianter",
      "stock": "{count} på lager",
      "sold": "{count} solgt",
      "publishSafety": "Første kørsel skriver intet. Den endelige kørsel aktiverer produkterne og udgiver dem direkte på Online Store. Lageret på eksisterende Shopify-varianter overskrives ikke.",
      "dryRun": "Test uden at skrive",
      "publishActive": "Udgiv aktive produkter",
      "confirmTitle": "Udgiv produktpiloten i Shopify?",
      "confirmMessage": "{products} produkter med i alt {variants} aktive varianter oprettes eller opdateres, aktiveres og udgives direkte på Online Store. Lageret på eksisterende Shopify-varianter overskrives ikke.",
      "dryRunDone": "Piloten er testet",
      "liveDone": "Produktpiloten er sendt til Shopify",
      "resultSummary": "{succeeded} lykkedes · {failed} fejlede",
      "dryRunResult": "Resultat af testkørslen",
      "liveResult": "Resultat fra Shopify",
      "variantResult": "{created} nye varianter · {updated} opdaterede · {images} billeder",
      "bulkHeading": "Masseoverførsel",
      "bulkHint": "Bølgerne kører i baggrunden og fortsætter efter en genstart. Produkterne aktiveres og udgives direkte på Online Store.",
      "waveOneTitle": "Bølge 1 · varer på lager",
      "waveOneDetail": "{count} klargjorte produkter med lager overføres først.",
      "waveTwoTitle": "Bølge 2 · tidligere solgte varer",
      "waveTwoDetail": "{count} klargjorte, udsolgte produkter med salgshistorik kan overføres bagefter.",
      "startWaveOne": "Start bølge 1",
      "startWaveTwo": "Start bølge 2",
      "waveThreeTitle": "Bølge 3 · kan bestilles uden lager",
      "waveThreeDetail": "{count} klargjorte produkter uden lager eller salgshistorik må købes ifølge Dandomain.",
      "startWaveThree": "Start bølge 3",
      "startAll": "Overfør alle klargjorte",
      "startWave": "Start overførslen",
      "bulkConfirmTitle": "Start masseoverførsel til Shopify?",
      "bulkConfirmMessage": "{count} produkter oprettes eller opdateres, aktiveres og udgives på Online Store. Jobbet kan fortsætte efter en genstart, og fejl kan genkøres særskilt.",
      "bulkQueued": "Masseoverførslen er startet",
      "bulkQueuedDetail": "{count} produkter ligger nu i den genoptagelige kø.",
      "jobCounts": "{done} af {total} behandlet · {ok} lykkedes · {errors} fejl",
      "currentProduct": "Arbejder på",
      "stopJob": "Stop efter denne vare",
      "retryFailures": "Genkør fejl",
      "showErrors": "Vis fejl ({count})",
      "waves": {
        "InStock": "Bølge 1 · varer på lager",
        "SoldOutWithSales": "Bølge 2 · tidligere solgte varer",
        "AvailableToOrder": "Bølge 3 · kan bestilles uden lager",
        "AllReady": "Alle klargjorte produkter",
        "RetryFailures": "Genkørsel af fejl"
      },
      "jobStatus": {
        "Queued": "I kø",
        "Running": "Kører",
        "Completed": "Færdig",
        "CompletedWithErrors": "Færdig med fejl",
        "Cancelled": "Stoppet",
        "Failed": "Fejlet"
      },
      "actions": {
        "Created": "Oprettes",
        "Updated": "Opdateres",
        "Failed": "Fejlet"
      }
    },
    "webhookUrl": "Webhook-adresse til shoppen",
    "webhookCopied": "Webhook-adresse kopieret",
    "copyWebhook": "Kopiér webhook-adresse",
    "secretStored": "Nøgle gemt",
    "secretMissing": "Nøgle mangler",
    "needsFixing": "(kræver rettelse)",
    "platform": "Platform",
    "dandomain": {
      "username": "Brugernavn",
      "usernamePlaceholder": "butik{'@'}eksempel.dk",
      "usernameHint": "E-mailadressen på Dandomain-brugeren, API-adgangen hænger på. Det er ikke en butiksadresse — endpointet er det samme for alle.",
      "imageBase": "Billed-URL",
      "imageBasePlaceholder": "https://shop12598.sfstatic.io/upload_dir/shop/",
      "imageBaseHint": "Dandomain sender kun filnavnet på et billede — værten hører til butikken. Uden den her henter migreringen ingen varebilleder. Find den ved at højreklikke på et billede i shoppen og kopiere billedadressen, og tag alt til og med den sidste skråstreg.",
      "password": "Adgangskode",
      "note": "Dandomain er kun til migrering. Der er ingen webhooks og ingen løbende ordresynkronisering herfra — varer, kunder og ordrehistorik hentes under Dataflytning.",
      "openMigration": "Dataflytning"
    },
    "shopAddress": "Butiksadresse",
    "shopAddressPlaceholder": "dinbutik.myshopify.com",
    "shopAddressHint": "Brug den permanente adresse, ikke jeres eget domæne — det er den, webhooks kommer fra.",
    "clientId": "Klient-id",
    "clientSecret": "Hemmelighed",
    "clientCredentialsHint": "Fra appen i Shopifys Dev Dashboard under Indstillinger → Legitimationsoplysninger. smibo bytter dem selv til et dagligt adgangstoken, og hemmeligheden bruges også til at kontrollere appens webhooks. Appen skal være installeret i butikken.",
    "accessToken": "Adgangstoken (ældre app med fast token)",
    "webhookSecret": "Webhook-nøgle",
    "webhookSecretHint": "Findes i Shopify under Notifications → Webhooks.",
    "storedReplace": "— gemt, udfyld kun for at udskifte",
    "fetchOrdersFrom": "Hent ordrer fra",
    "fetchOrdersFromHint": "Ordrer før denne dato hentes ikke. Lad stå tom for de sidste syv dage.",
    "runStatus": {
      "Running": "Kører",
      "Completed": "Gennemført",
      "CompletedWithErrors": "Gennemført med fejl",
      "Failed": "Fejlet",
      "Abandoned": "Afbrudt"
    }
  },
  "migration": {
    "title": "Dataflytning fra Dandomain",
    "subtitle": "Henter kategorier, varer, kunder og ordrehistorik ind i smibo. Der bliver aldrig skrevet noget tilbage til Dandomain — butikken kan køre videre imens.",
    "loadFailed": "Kunne ikke hente migreringer.",
    "noConnection": "Opret først en Dandomain-forbindelse under {channels} med brugernavn og adgangskode til shoppens API.",
    "connection": "Forbindelse",
    "chooseConnection": "Vælg forbindelse",
    "ordersFrom": "Ordrer fra",
    "ordersTo": "Ordrer til",
    "everything": "Alt",
    "deltaOption": "Opsamling (kun det nye siden sidst)",
    "notConfigured": "{name} mangler brugernavn og adgangskode til Dandomains API. Udfyld dem under {channels}, før du starter.",
    "rerunHint": "Kør den så mange gange du vil. Hver kørsel opdaterer det, der allerede er hentet, i stedet for at oprette det igen — så en afbrudt kørsel kan bare startes forfra.",
    "start": "Start migrering",
    "started": "Migrering startet",
    "startedDetail": "Den kører videre i baggrunden — du kan roligt forlade siden.",
    "startFailed": "Kunne ikke starte migreringen.",
    "stop": "Stop",
    "stopping": "Stopper",
    "stoppingDetail": "Migreringen afslutter den post, den er i gang med. Intet af det hentede går tabt.",
    "stopFailed": "Kunne ikke stoppe migreringen.",
    "refresh": "Opdater",
    "latestRun": "Seneste kørsel",
    "ordersThrough": "Ordrer er hentet til og med {date}. En ny kørsel fortsætter derfra.",
    "justStarted": "Kørslen er lige startet.",
    "andMore": "… og {count} mere.",
    "earlierRuns": "Tidligere kørsler",
    "noEarlierRuns": "Ingen tidligere kørsler.",
    "delta": "Opsamling",
    "full": "Fuld",
    "errors": {
      "noCredentials": "Forbindelsen mangler brugernavn og adgangskode til Dandomains API.",
      "abandoned": "Kørslen stoppede uventet — serveren blev genstartet undervejs. Start en ny; den fortsætter fra den dato, ordrerne nåede til."
    },
    "live": {
      "working": "Arbejder på {phase}",
      "starting": "Starter op …",
      "seen": "{count} fundet",
      "heartbeat": "livstegn {when}",
      "secondsAgo": "for {count} sek. siden",
      "minutesAgo": "for {count} min. siden",
      "orderWindow": "Ordrer {from} til {to}",
      "stalled": "Ingen livstegn i over et kvarter. Kørslen er sandsynligvis død — en ny kan startes, og den fortsætter fra den dato, ordrerne nåede til."
    },
    "probe": {
      "button": "Kig i shoppen",
      "running": "Kigger …",
      "intro": "Forbinder, tæller hvad der ligger, og viser et par rækker som de ville se ud herinde. Der bliver hverken skrevet til Dandomain eller til smibo, så den kan køres midt i en travl dag.",
      "heading": "Hvad ligger der i Dandomain",
      "failed": "Kunne ikke kigge i shoppen.",
      "notConnected": "Kunne ikke forbinde til Dandomain.",
      "atLeast": "mindst {count}",
      "window": "{from} – {to}",
      "noRows": "Ingen rækker."
    },
    "columns": {
      "phase": "Trin",
      "seen": "Fundet",
      "created": "Oprettet",
      "updated": "Opdateret",
      "skipped": "Sprunget over",
      "failed": "Fejl",
      "started": "Startet",
      "type": "Type",
      "result": "Resultat",
      "finished": "Afsluttet"
    },
    "phase": {
      "Categories": "Kategorier",
      "Products": "Produkter",
      "Customers": "Kunder",
      "Orders": "Ordrer"
    },
    "status": {
      "Running": "Kører",
      "Completed": "Fuldført",
      "CompletedWithErrors": "Fuldført med fejl",
      "Failed": "Fejlet",
      "Cancelled": "Afbrudt"
    }
  },
  "reports": {
    "title": "Rapporter",
    "subtitle": "Målt på hvad der er sendt afsted, ikke på hvad der er bestilt. Alle beløb er inkl. moms.",
    "loadFailed": "Kunne ikke hente tallene.",
    "show": "Vis",
    "revenue": "Omsætning",
    "changeVsPrevious": "{change} % mod forrige periode",
    "noPrevious": "Ingen omsætning i forrige periode",
    "ordersShipped": "Ordrer sendt",
    "shipmentCount": "{count} forsendelser",
    "averageOrder": "Gennemsnitsordre",
    "beforeReturns": "Før returer",
    "refunded": "Returneret",
    "paidOutInPeriod": "Udbetalt i perioden",
    "revenuePerDay": "Omsætning pr. dag",
    "bestSellers": "Mest solgte",
    "nothingShipped": "Ingenting sendt i perioden.",
    "units": "Stk.",
    "vatInPeriod": "Moms i perioden",
    "vatTotal": "Moms i alt",
    "vatSplitHint": "Opdelt på både sats og årsag: omvendt betalingspligt og eksport er begge 0 % og skal i hver sin rubrik.",
    "stockValue": "Lagerværdi",
    "atCost": "Til kostpris",
    "skusInStock": "Varenumre på lager",
    "unitsInStock": "Enheder",
    "withoutCostPrice": "{count} varenumre har lager uden kostpris og tæller som nul. Værdien ovenfor er for lav.",
    "noSalesIn": "Ingen salg i {days} dage",
    "everythingMoved": "Alt på lageret har bevæget sig.",
    "valuePerMonth": "Værdi pr. måned",
    "startedInPeriod": "Nye i perioden",
    "cancelledInPeriod": "Opsagt i perioden",
    "quarterlyHint": "Kvartalsabonnementer er regnet om til måned, så tallene kan lægges sammen."
  },
  "login": {
    "title": "Log ind",
    "subtitle": "Log ind for at fortsætte.",
    "rememberMe": "Hold mig logget ind",
    "forgotPassword": "Glemt adgangskode?",
    "resendConfirmation": "Send bekræftelseslinket igen",
    "confirmationSent": "Sendt. Kig i din indbakke — og i spamfilteret."
  },
  "notFound": {
    "body": "Den side findes ikke.",
    "back": "Tilbage til overblikket"
  },
  "members": {
    "subtitle": "Konti i {workspace}. Den samme e-mailadresse kan høre til et andet arbejdsområde uafhængigt af dette.",
    "add": "Tilføj bruger",
    "added": "Brugeren er tilføjet",
    "empty": "Ingen brugere fundet.",
    "roles": "Roller",
    "role": "Rolle",
    "lastSignIn": "Sidst logget ind",
    "never": "Aldrig",
    "active": "Aktiv",
    "deactivated": "Deaktiveret",
    "deactivate": "Deaktivér",
    "deactivateTitle": "Deaktivér bruger",
    "deactivateFailed": "Kunne ikke deaktivere",
    "loadFailed": "Kunne ikke hente brugere.",
    "deactivateBody": "{name} kan ikke længere logge ind. Historikken bevares.",
    "platformAccount": "Platformkonto",
    "invitationHint": "Der oprettes ingen adgangskode. Kollegaen får et link og vælger selv.",
    "invited": "Brugeren er oprettet",
    "invitationLinkBody": "Send linket her til din kollega. Det vises kun nu, og det er også sendt på mail."
  },
  "signUpWorkspace": {
    "title": "Opret et arbejdsområde",
    "subtitle": "Du bliver dets første ejer.",
    "workspaceName": "Arbejdsområdets navn",
    "address": "Arbejdsområdets adresse",
    "addressHint": "Bruges som jeres underdomæne og i arbejdsområde-headeren.",
    "checking": "Tjekker om den er ledig…",
    "available": "{slug} er ledig",
    "unavailable": "Adressen er optaget.",
    "firstName": "Fornavn",
    "lastName": "Efternavn",
    "email": "Arbejdsmail",
    "password": "Adgangskode",
    "passwordHint": "Mindst 10 tegn, med store og små bogstaver, et tal og et tegn.",
    "submit": "Opret arbejdsområde",
    "haveOne": "Har du allerede et arbejdsområde? {signIn}",
    "signIn": "Log ind",
    "noServer": "Kunne ikke få fat i serveren. Kører API'et?"
  },
  "dashboard": {
    "subtitle": "Hvad der venter lige nu.",
    "refresh": "Opdatér overblikket",
    "loadFailed": "Kunne ikke hente overblikket.",
    "needsAction": "Kræver handling:",
    "allClear": "Der er ikke noget udestående. Godt gået.",
    "configuredUnder": "Panelerne vælges pr. workspace under {settings}.",
    "settingsLink": "opsætning",
    "widget": {
      "orders": {
        "new": {
          "title": "Nye ordrer",
          "hint": "Modtaget, ikke behandlet endnu"
        },
        "ready": {
          "title": "Klar til pak",
          "hint": "Alt er reserveret på lageret"
        },
        "backordered": {
          "title": "I restordre",
          "hint": "Venter på en aftalt leverandørdato"
        }
      },
      "purchasing": {
        "needed": {
          "title": "Mangler bestilling",
          "hint": "Varer på ordre, som hverken er på lager eller bestilt"
        },
        "overdue": {
          "title": "Forsinkede leverancer",
          "hint": "Indkøbsordrer over forventet leveringsdato"
        }
      },
      "subscriptions": {
        "due": {
          "title": "Abonnementer forfalder",
          "hint": "Trækkes og sendes snart"
        },
        "failed": {
          "title": "Abonnementer med betalingsfejl",
          "hint": "Betaling mislykkedes gentagne gange"
        }
      },
      "stock": {
        "low": {
          "title": "Lavt lager",
          "hint": "Varer under deres minimumslager"
        }
      },
      "messages": {
        "failed": {
          "title": "Beskeder der fejlede",
          "hint": "Kunne ikke sendes efter flere forsøg"
        }
      }
    },
    "detail": {
      "oldestToday": "Ældste kom i dag",
      "oldestDays": "Ældste er {count} dag gammel | Ældste er {count} dage gammel",
      "nothingReady": "Intet klar lige nu",
      "packableNow": "Kan pakkes med det samme",
      "allOnOrder": "Alt er bestilt hjem",
      "unitsWaiting": "{count} stk. kunder venter på",
      "awaitingDate": "Afventer aftalt leveringsdato",
      "shouldHaveArrived": "Skulle være leveret",
      "overdueCount": "{count} er forfalden | {count} er forfaldne",
      "withinSevenDays": "Inden for 7 dage",
      "contactCustomer": "Kunden skal kontaktes",
      "belowMinimum": "Under minimumslager",
      "neverArrived": "Nåede ikke frem"
    }
  },
  "products": {
    "title": "Produkter",
    "copy": {
      "edit": "Redigér tekst",
      "saved": "Teksten er gemt",
      "reset": "Hent fra shoppen igen",
      "ownedByShop": "Teksten kommer fra shoppen og opdateres ved hver dataflytning.",
      "ownedHere": "Teksten er skrevet her {at} og røres ikke af dataflytningen.",
      "confirmReset": "Overlad teksten til shoppen igen? Ordene bliver stående, men næste dataflytning overskriver dem.",
      "tagsHint": "Adskilt med komma.",
      "slugHint": "Adressen produktet ligger på, uden domæne. Ændrer du den, mister de eksisterende links deres mål."
    },
    "ai": {
      "title": "AI-forslag til produkttekst",
      "generate": "Lav AI-forslag",
      "showDraft": "Vis AI-forslag",
      "regenerate": "Lav nyt forslag",
      "generateFailed": "AI-forslaget kunne ikke laves",
      "draft": "Kladde",
      "intro": "Forslaget gælder hele produktfamilien med {count} variant(er). Ret teksten og vælg de felter, du vil bruge.",
      "review": "Kontrollér altid fakta. AI'en har kun fået de produktoplysninger, der allerede ligger i platformen.",
      "stale": "Produktdata er ændret, siden forslaget blev lavet. Lav et nyt forslag, før du godkender.",
      "htmlHint": "Enkel HTML er tilladt i beskrivelsen.",
      "searchPhrases": "Søgefraser",
      "searchPhrasesHint": "Til redaktionelt arbejde og intern søgning. Shopify og Google bruger ikke meta-keywords.",
      "notPublished": "Godkendelse gemmer i platformen, men udgiver ikke automatisk til Shopify.",
      "apply": "Godkend valgte felter",
      "applied": "Forslaget er gemt på {count} variant(er)",
      "discard": "Kassér forslag",
      "confirmDiscard": "Kassér dette AI-forslag? Produktdata ændres ikke.",
      "errors": {
        "noGenerator": "OpenAI er ikke sat op under Opkoblinger.",
        "monthlyLimit": "Arbejdsområdet har nået månedens grænse for produktoptimeringer.",
        "productNotFound": "Produktet findes ikke.",
        "suggestionNotFound": "AI-forslaget findes ikke.",
        "notDraft": "Forslaget er allerede afsluttet.",
        "stale": "Produktdata er ændret siden forslaget blev lavet. Lav et nyt forslag.",
        "noFields": "Vælg mindst ét felt."
      }
    },
    "detail": {
      "sku": "Varenummer",
      "ean": "Stregkode",
      "retailPrice": "Salgspris",
      "guidelinePrice": "Vejl. pris",
      "allowPurchaseWhenOutOfStock": "Køb uden lager",
      "stockPolicy": { "allowed": "Tilladt", "denied": "Ikke tilladt", "unknown": "Uafklaret" },
      "costPrice": "Kostpris",
      "stock": "Lager",
      "weight": "Vægt",
      "unit": "Enhed",
      "location": "Placering",
      "supplier": "Leverandør",
      "categories": "Kategorier",
      "primary": "Primær",
      "siblings": "Andre varianter",
      "shortDescription": "Kort beskrivelse",
      "description": "Beskrivelse",
      "longDescription": "Uddybende tekst",
      "tags": "Tags",
      "seo": "Søgemaskiner",
      "seoTitle": "Titel",
      "seoSlug": "Adresse",
      "seoDescription": "Beskrivelse",
      "seoKeywords": "Nøgleord",
      "noImages": "Ingen billeder",
      "active": "Aktiv",
      "inactive": "Ikke aktiv",
      "source": "Hentet fra {channel}",
      "openInShop": "Se i shoppen"
    },
    "policy": {
      "title": "Salg og synlighed",
      "familyHint": "Ændringen gælder alle varianter i produktfamilien. Lagerantal ændres ikke.",
      "lifecycleLabel": "Livscyklus",
      "visibilityLabel": "Synlighed i webshop",
      "supplyLabel": "Forsyningsform",
      "reason": "Begrundelse",
      "reasonPlaceholder": "fx bestilles hjem efter salg",
      "auditHint": "Før- og efterværdier gemmes i ændringsloggen.",
      "sync": {
        "queued": "Shopify afventer",
        "processing": "Shopify opdateres",
        "completed": "Shopify afstemt",
        "failed": "Shopify genprøver",
        "needsAttention": "Shopify kræver handling"
      },
      "lifecycle": {
        "draft": "Kladde",
        "readyForReview": "Klar til gennemgang",
        "approved": "Godkendt",
        "rejected": "Afvist",
        "archived": "Arkiveret"
      },
      "visibility": {
        "unspecified": "Ikke afklaret",
        "hidden": "Skjult",
        "whenInStock": "Synlig ved disponibelt lager",
        "always": "Altid synlig"
      },
      "supply": {
        "unspecified": "Ikke afklaret",
        "stocked": "Lagervare",
        "orderOnDemand": "Bestillingsvare",
        "dropShip": "Dropship",
        "service": "Ydelse"
      }
    },
    "manual": {
      "create": "Opret produkt",
      "createDraft": "Opret kladde",
      "created": "Produktkladden er oprettet",
      "name": "Produktnavn",
      "draftHint": "Produktet oprettes som skjult kladde. Tilføj kategori og indhold, og vælg derefter salgsreglerne i Redigér vare."
    },
    "subtitle": "Lager, placering og leverandør. Navn og pris kommer fra shoppen.",
    "searchPlaceholder": "Varenr., navn, stregkode",
    "allSuppliers": "Alle leverandører",
    "allBrands": "Alle mærker",
    "noBrand": "Intet mærke",
    "belowMinimum": "Under minimum",
    "withoutSupplier": "Uden leverandør",
    "empty": "Ingen produkter fundet.",
    "loadFailed": "Kunne ikke hente produkterne.",
    "saved": "Varen er gemt",
    "freeOfOnHand": "{free} fri af {onHand}",
    "onTheWay": "{count} på vej",
    "supplierMissing": "Mangler",
    "notPurchased": "Bestilles ikke",
    "adjustStock": "Regulér lager",
    "editProduct": "Redigér vare",
    "stockAdjusted": "Lageret er reguleret",
    "stockAdjustFailed": "Lageret blev ikke reguleret",
    "stockIntro": "{name} — talt beholdning. Reservationer fordeles igen med det samme, så ekstra varer straks frigives til dem der venter.",
    "reasonPlaceholder": "fx optælling, svind, retur",
    "pickLocationPlaceholder": "fx B-04-2",
    "noCategory": "Ingen kategori",
    "choose": "Vælg",
    "primaryCategoryHint": "Den kategori varen \"hører til\" — den der vises i brødkrummer. Vælges der ingen, bruges den første.",
    "restockHint": "Sættes normalt automatisk, når en indkøbsordre markeres som bestilt.",
    "excludeFromPurchasing": "Bestilles ikke hjem",
    "excludeHint": "Til ydelser og gaveindpakning — holder aldrig en ordre tilbage og optræder ikke i indkøb.",
    "variantCount": "{count} varianter",
    "partlyActive": "{count} aktive",
    "stockFilter": {
      "any": "Alt lager",
      "inStock": "På lager",
      "outOfStock": "Udsolgt",
      "belowMinimum": "Under minimum"
    },
    "sort": {
      "name": "Sortér: navn",
      "stockDescending": "Sortér: mest på lager",
      "stockAscending": "Sortér: mindst på lager"
    },
    "columns": {
      "location": "Placering",
      "demand": "Efterspørgsel",
      "price": "Pris",
      "state": "Status"
    },
    "fields": {
      "minimumStock": "Minimumslager",
      "pickLocation": "Lagerplacering",
      "supplierSku": "Leverandørens varenr.",
      "restockExpected": "Forventet på lager",
      "primaryCategory": "Primær kategori",
      "countedStock": "Antal på lager"
    },
    "errors": {
      "minimumStockNegative": "Minimumslager kan ikke være negativt.",
      "supplierNotFound": "Leverandøren findes ikke.",
      "brandNotFound": "Mærket findes ikke.",
      "stockReasonRequired": "Angiv en årsag til lagerreguleringen.",
      "categoriesNotFound": "En eller flere kategorier findes ikke.",
      "primaryNotAmongChosen": "Primærkategorien skal være blandt de valgte."
    },
    "missing": {
      "none": "Alle produkter",
      "image": "Mangler billede",
      "costPrice": "Mangler kostpris",
      "costPriceWithStock": "Lager uden kostpris",
      "supplier": "Mangler leverandør",
      "brand": "Mangler mærke",
      "description": "Mangler beskrivelse",
      "weight": "Mangler vægt",
      "ean": "Mangler stregkode",
      "weightSuspect": "Vægt der ikke kan passe"
    },
    "gaps": {
      "label": "Huller i kataloget:",
      "of": "af {total} produkter",
      "fillWeight": "Udfyld {count} fra leverandørkataloget",
      "fillWeightNone": "Leverandørkatalogerne har ingen vægt på dem",
      "fillWeightDone": "Vægt sat på {filled} varenumre fra leverandørkatalogerne.",
      "fillWeightDisagree": "{count} stregkoder, hvor to leverandører er uenige om vægten — udfyldt med den første:"
    }
  },
  "brands": {
    "title": "Mærker",
    "subtitle": "Mærkerne i kataloget, og de numre fra butikken der endnu ikke har et navn.",
    "newBrand": "Nyt mærke",
    "editBrand": "Redigér mærke",
    "name": "Navn",
    "sourceId": "Butikkens id",
    "sourceIdHint": "Dandomains producent-id. Skriver du det ind, overtager mærket alle varer der bærer det.",
    "active": "Vises i lister",
    "hidden": "Skjult",
    "productCount": "{count} varer",
    "empty": "Der er ingen mærker endnu.",
    "loadFailed": "Mærkerne kunne ikke hentes.",
    "saved": "Mærket er gemt",
    "claimed": "{count} varer hører nu til {name}.",
    "nameIt": "Giv det et navn",
    "nameItAs": "Kald det {name}",
    "merge": "Læg ind i et andet mærke",
    "mergeInto": "Læg ind i",
    "mergeIntro": "{name} har {count} varer. De flyttes til det mærke, du vælger, og {name} slettes.",
    "merged": "Mærkerne er lagt sammen",
    "confirmDelete": "Slet mærket {name}?",
    "unmapped": {
      "title": "Uden navn endnu",
      "intro": "Dandomain oplyser kun et nummer for et mærke og har intet endpoint, der kan slå navnet op. {count} produkter venter på et navn — de største først. Forslaget er de ord, produkternes titler deler; læs det efter, før du gemmer."
    }
  },
  "variantTypes": {
    "title": "Varianttyper",
    "subtitle": "De akser sortimentet varierer på — farve, størrelse, længde — og værdierne på hver.",
    "newType": "Ny type",
    "editType": "Redigér type",
    "newValue": "Ny værdi",
    "editValue": "Redigér værdi",
    "name": "Navn",
    "sortOrder": "Rækkefølge",
    "active": "Vises i lister",
    "hidden": "Skjult",
    "colorHex": "Farvekode",
    "colorHint": "Hex-kode som #1b3a4b. Bruges til farveprikken — et navn som \"Petrol\" siger mindre end firkanten.",
    "imageUrl": "Billede",
    "valueCount": "{count} værdier",
    "noValues": "Ingen værdier på denne type endnu.",
    "empty": "Der er ingen varianttyper endnu. De kommer med fra shoppen ved næste dataflytning, eller du kan oprette dem her.",
    "loadFailed": "Varianttyperne kunne ikke hentes.",
    "unusedHint": "{count} værdier bruges ikke af nogen produkter. De står svagere i listen.",
    "confirmDeleteType": "Slet typen {name}? Det kan kun lade sig gøre, hvis ingen produkter bruger den.",
    "confirmDeleteValue": "Slet værdien {name}?",
    "colorPlaceholder": "#1b3a4b"
  },
  "categories": {
    "title": "Kategorier",
    "subtitle": "Butikkens struktur. En vare kan ligge i flere kategorier, men har altid én primær.",
    "newCategory": "Ny kategori",
    "editCategory": "Redigér kategori",
    "empty": "Der er ingen kategorier endnu.",
    "loadFailed": "Kunne ikke hente kategorier.",
    "saved": "Kategorien er gemt",
    "deleteTitle": "Slet kategori",
    "deleteBody": "Slet \"{name}\"? Det kan kun lade sig gøre, hvis den hverken har underkategorier eller varer.",
    "deleted": "Kategorien er slettet",
    "deleteFailed": "Kunne ikke slette",
    "hidden": "Skjult",
    "addChild": "Tilføj underkategori",
    "topLevel": "— Ingen (topniveau) —",
    "noCycleHint": "Underkategorier af denne kan ikke vælges — det ville lave en løkke.",
    "sortOrderHint": "Laveste tal først blandt kategorier på samme niveau.",
    "visibleInShop": "Vises i butikken",
    "fields": {
      "name": "Navn",
      "parent": "Ligger under",
      "sortOrder": "Rækkefølge",
      "description": "Beskrivelse"
    },
    "errors": {
      "nameRequired": "Navn er påkrævet.",
      "hasChildren": "Kategorien har underkategorier. Flyt dem først.",
      "hasProducts": "Kategorien har varer. Flyt dem først, eller deaktivér den.",
      "wouldCreateCycle": "En kategori kan ikke placeres under sig selv eller en af sine underkategorier."
    },
    "searchPlaceholder": "Søg i kategorier",
    "expandAll": "Fold alle ud",
    "collapseAll": "Fold alle sammen",
    "count": "{shown} af {total}"
  },
  "orders": {
    "title": "Ordrer",
    "subtitle": "Søg i alle ordrer, også afsendte og annullerede.",
    "searchPlaceholder": "Ordrenr., kunde, e-mail eller varenr.",
    "empty": "Ingen ordrer fundet.",
    "loadFailed": "Kunne ikke hente ordrer.",
    "columns": {
      "order": "Ordre",
      "date": "Dato",
      "customer": "Kunde",
      "status": "Status",
      "payment": "Betaling",
      "amount": "Beløb"
    },
    "age": {
      "today": "I dag",
      "yesterday": "I går"
    },
    "errors": {
      "notFound": "Ordren findes ikke.",
      "closed": "Ordren er afsluttet.",
      "lineNotFound": "Ordrelinjen findes ikke.",
      "alreadyBeingPicked": "En anden pakker er allerede i gang med ordren.",
      "quantityNegative": "Antal kan ikke være negativt.",
      "quantityAtLeastOne": "Antal skal være mindst 1.",
      "priceNegative": "Prisen kan ikke være negativ.",
      "shippingNegative": "Fragt kan ikke være negativ.",
      "nothingToCancel": "Der er intet udestående på linjen at annullere.",
      "productNotFound": "Varen findes ikke.",
      "scanEmpty": "Scan en stregkode.",
      "nothingPicked": "Ingen varer er plukket endnu.",
      "notReadyForPickup": "Ordren er ikke klar til afhentning.",
      "alreadyDispatched": "Ordren er allerede afsendt.",
      "subjectRequired": "Emne er påkrævet.",
      "onlyAllocated": "Der er kun reserveret {count} stk. til denne ordre.",
      "alreadyShipped": "Der er allerede afsendt {count} stk. Brug en retur i stedet.",
      "scanNotOnOrder": "{code} hører ikke til denne ordre. Læg varen tilbage.",
      "scanAlreadyComplete": "{name}: der er allerede {count} stk. i kassen, og der er ikke reserveret flere.",
      "scanNothingReserved": "{name} er på ordren, men der er ikke reserveret lager til den. Den skal ikke med i denne pakke.",
      "scanCancelled": "{name} er annulleret på denne ordre. Læg varen tilbage."
    },
    "status": {
      "Received": "Modtaget",
      "InProgress": "Under behandling",
      "PartiallyShipped": "Delvist afsendt",
      "Shipped": "Afsendt",
      "ReadyForPickup": "Klar til afhentning",
      "PickedUp": "Afhentet",
      "Cancelled": "Annulleret",
      "Refunded": "Refunderet"
    },
    "fulfillment": {
      "Ready": "Klar til pak",
      "PartiallyReady": "Delvist klar",
      "Backordered": "I restordre",
      "AwaitingStock": "Mangler bestilling",
      "Complete": "Afsluttet"
    },
    "fulfillmentHint": {
      "Ready": "Alt er på lager og reserveret",
      "PartiallyReady": "Noget kan sendes nu",
      "Backordered": "Afventer aftalt leveringsdato",
      "AwaitingStock": "Skal bestilles hjem",
      "Complete": "Intet udestående"
    },
    "lineStatus": {
      "Waiting": "Afventer",
      "Allocated": "Reserveret",
      "Picked": "Plukket",
      "Shipped": "Afsendt",
      "Cancelled": "Annulleret"
    },
    "paymentStatus": {
      "None": "Ingen betaling",
      "Authorized": "Reserveret",
      "Captured": "Hævet",
      "PartiallyRefunded": "Delvist refunderet",
      "Refunded": "Refunderet",
      "Failed": "Fejlet"
    },
    "vatTreatment": {
      "Domestic": "Dansk moms",
      "OssEuB2c": "EU-forbruger (OSS)",
      "ReverseCharge": "Omvendt betalingspligt",
      "Export": "Eksport uden for EU",
      "Exempt": "Momsfritaget"
    }
  },
  "orderDetail": {
    "crumb": "Ordre {number}",
    "back": "Tilbage til pakkelisten",
    "loadFailed": "Kunne ikke hente ordren.",
    "packingSlip": "Følgeseddel",
    "messageCustomer": "Skriv til kunden",
    "startPicking": "Start pluk",
    "pickingStarted": "Du pakker nu ordren",
    "abandonPicking": "Afbryd pluk",
    "pickingAbandoned": "Pluk afbrudt",
    "pickAllAllocated": "Pluk alt reserveret",
    "allPicked": "Alt reserveret er plukket",
    "finishAndSend": "Afslut og send",
    "markReadyForPickup": "Markér klar til afhentning",
    "readyForPickup": "Klar til afhentning",
    "dispatched": "Ordren er afsendt",
    "confirmPickup": "Bekræft afhentning",
    "markedPickedUp": "Markeret som afhentet",
    "cancelTitle": "Annullér ordre",
    "cancelBody": "Reserveret lager frigives til de næste ordrer i køen. Allerede afsendte varer berøres ikke.",
    "cancelConfirm": "Annullér ordren",
    "cancelled": "Ordren er annulleret",
    "unitsPicked": "{count} plukket",
    "completeOn": "komplet {date}",
    "pickedBy": "{name} pakker denne ordre",
    "pickedSince": "(siden {time})",
    "customerNote": "Besked fra kunden:",
    "scanPlaceholder": "Scan stregkode — én scanning pr. vare",
    "scanAccepted": "{code} lagt i kassen",
    "scanRejected": "Scanningen blev afvist.",
    "unknownProduct": "Varenummeret findes ikke i kataloget — kan ikke reserveres automatisk.",
    "restockExpected": "forventet {date}",
    "noRestockDate": "ingen leveringsdato",
    "figures": {
      "allocated": "Reserveret"
    },
    "shipments": "Forsendelser",
    "printLabel": "Print label",
    "printAgain": "Print igen",
    "pickupCarrier": "Afhentning",
    "awaitingChannelSync": "afventer overførsel til shoppen",
    "shippingAddress": "Leveringsadresse",
    "attentionOf": "att. {name}",
    "delivery": "Levering",
    "method": "Metode",
    "servicePoint": "Pakkeshop",
    "shipping": "Fragt",
    "payment": "Betaling",
    "goods": "Varer",
    "discount": "Rabat",
    "totalExVat": "I alt ekskl. moms",
    "vat": "Moms",
    "buyerVatNumber": "Købers momsnr.",
    "total": "I alt",
    "authorized": "Reserveret",
    "internalNote": "Intern note",
    "internalOnly": "Kun synlig internt",
    "noteSaved": "Noten er gemt",
    "noteSaveFailed": "Noten blev ikke gemt",
    "dispatchIntro": "{count} stk. registreres som afsendt og trækkes fra lageret.",
    "dispatchIntroPickup": "{count} stk. registreres som klar i butikken og trækkes fra lageret.",
    "trackingNumber": "Fragtbrevnummer",
    "message": {
      "defaultSubject": "Vedr. din ordre {number}",
      "intro": "Sendes til {email} og gemmes på ordren, så svaret kan findes igen.",
      "subject": "Emne",
      "body": "Besked",
      "variablesHint": "Du kan bruge {sender} og {support} som i skabelonerne.",
      "send": "Send",
      "sent": "Besked sendt",
      "notSent": "Beskeden blev ikke sendt",
      "seeLog": "Se beskedloggen.",
      "sendFailed": "Kunne ikke sende"
    }
  },
  "packing": {
    "title": "Pakkeliste",
    "subtitle": "Ordrer der mangler at blive sendt. Øverst står dem der kan pakkes med det samme.",
    "loadFailed": "Kunne ikke hente pakkelisten.",
    "printSelected": "Print {count} følgeseddel | Print {count} følgesedler",
    "printAllReady": "Print alle klar ({count})",
    "updatedAt": "Opdateret {time}",
    "refresh": "Opdatér listen",
    "truncated": "Der er flere åbne ordrer end listen viser. Brug søgefeltet for at indsnævre.",
    "filter": "Filter: {state}",
    "clearFilter": "Ryd filter",
    "orderCount": "{count} ordrer",
    "empty": "Ingen ordrer venter. Godt gået.",
    "needsPurchasing": "Skal bestilles",
    "allocated": "{allocated}/{outstanding} stk. reserveret",
    "unitsShort": "{count} stk. mangler",
    "completeOn": "Komplet {date}",
    "customerNote": "Kundebesked",
    "internalNote": "Intern note",
    "internalNoteTooltip": "Der er en intern note på ordren",
    "pack": "Pak",
    "open": "Åbn",
    "columns": {
      "coverage": "Dækning",
      "delivery": "Levering"
    }
  },
  "packingSlips": {
    "title": "Følgeseddel",
    "print": "Print",
    "slipCount": "{count} følgeseddel | {count} følgesedler",
    "noneSelected": "Ingen ordrer valgt.",
    "loadFailed": "Kunne ikke hente ordrerne.",
    "shipTo": "Sendes til",
    "pickup": "Afhentes i butikken",
    "servicePoint": "Pakkeshop {id}",
    "follows": "{count} stk. følger senere",
    "customerNote": "Besked fra kunden",
    "footer": "Tak for din ordre. Skal noget retur, så kontakt os først — så finder vi ud af det.",
    "columns": {
      "location": "Placering",
      "sku": "Varenr.",
      "product": "Vare",
      "quantity": "Antal"
    }
  },
  "shippingRules": {
    "title": "Fragtregler",
    "subtitle": "Bestemmer hvilket fragtprodukt der bookes, når en ordre sendes. Reglerne læses oppefra og ned — den første, der passer, vinder.",
    "newRuleButton": "Ny regel",
    "newRule": "Ny fragtregel",
    "editRule": "Rediger fragtregel",
    "loadFailed": "Kunne ikke hente fragtreglerne.",
    "saved": "Gemt",
    "saveFailed": "Kunne ikke gemme reglen.",
    "deleteTitle": "Slet fragtregel",
    "deleteBody": "Slet \"{description}\"? Ordrer, der matchede den, falder ned til næste regel.",
    "deleteFailed": "Kunne ikke slette reglen.",
    "noRules": "Der er ingen fragtregler. Uden mindst én bliver der ikke booket nogen fragtlabel, når en ordre afsendes — pakken bliver registreret som sendt uden pakkelabel.",
    "noLabel": "Ingen label",
    "active": "Aktiv",
    "inactive": "Slået fra",
    "all": "Alle",
    "lowestWins": "Lavest tal vinder.",
    "appliesTo": "Gælder for",
    "thenBook": "Book så",
    "noLabelHint": "Lad fragtfirma og produktkode stå tomme, hvis ordren ikke skal have en label.",
    "descriptionPlaceholder": "fx GLS pakkeshop, Danmark",
    "carrierPlaceholder": "fx gls",
    "serviceCodePlaceholder": "fx GLSDK_SD",
    "addOnsPlaceholder": "fx EMAIL_NT,SMS_NT",
    "columns": {
      "priority": "Nr.",
      "rule": "Regel",
      "product": "Fragtprodukt"
    },
    "fields": {
      "description": "Beskrivelse",
      "order": "Rækkefølge",
      "method": "Fragtmetode fra shoppen",
      "country": "Land",
      "countryCode": "Landekode",
      "pickup": "Afhentning",
      "servicePoint": "Pakkeshop valgt",
      "carrier": "Fragtfirma",
      "serviceCode": "Produktkode",
      "addOns": "Tilvalg"
    },
    "tristate": {
      "any": "Er lige meget",
      "yes": "Ja",
      "no": "Nej"
    },
    "criteria": {
      "method": "Fragtmetode {code}",
      "country": "Land {code}",
      "pickup": "Afhentning",
      "notPickup": "Ikke afhentning",
      "servicePoint": "Pakkeshop valgt",
      "noServicePoint": "Ingen pakkeshop",
      "everything": "Alle ordrer"
    },
    "test": {
      "title": "Prøv en ordre",
      "intro": "Udfyld som en rigtig ordre og se, hvilken regel der vinder. Der bookes ikke noget.",
      "methodPlaceholder": "fx 7",
      "run": "Afprøv",
      "hit": "Rammer {rule} → {carrier}",
      "noLabel": "ingen label",
      "noMatch": "Ingen regel passer. Sådan en ordre bliver afsendt uden fragtlabel."
    }
  },
  "purchasing": {
    "title": "Indkøb",
    "subtitle": "Varer der mangler — til kunder der venter, og til at fylde hylden op igen.",
    "loadSuggestionsFailed": "Kunne ikke hente indkøbsforslag.",
    "toPurchaseOrders": "Indkøbsordrer",
    "nothingToOrder": "Der er ikke noget at bestille lige nu.",
    "summary": "{units} stk. fordelt på {suppliers} leverandører",
    "orderDayToday": "Bestillingsdag i dag",
    "missingSupplier": "Mangler leverandør",
    "leadTimeDays": "{count} dages leveringstid",
    "createOrder": "Opret indkøbsordre",
    "noSupplierBody": "Disse varer har ingen leverandør og kan ikke bestilles automatisk. Tildel en leverandør på {productPage}.",
    "noSupplierLink": "varekortet",
    "belowMinimum": "Ordren er under leverandørens minimum på {amount}",
    "noProductsSelected": "Ingen varer valgt",
    "draftCreated": "Kladde {number} oprettet",
    "createFailed": "Kunne ikke oprette indkøbsordren",
    "lineCount": "{count} varelinjer",
    "ourSku": "vores {sku}",
    "waitingOrders": "{count} ordre | {count} ordrer",
    "freeStock": "{count} fri",
    "minimumStock": "min. {count}",
    "receivedOfOrdered": "{received}/{ordered} stk.",
    "noFixedOrderDays": "Ingen faste dage",
    "noSupplierGroup": "Uden leverandør",
    "errors": {
      "supplierNotFound": "Leverandøren findes ikke.",
      "noLines": "Vælg mindst én vare med et antal over nul.",
      "productsGone": "En eller flere varer findes ikke længere.",
      "orderNotFound": "Indkøbsordren findes ikke.",
      "alreadySent": "Indkøbsordren er allerede sendt.",
      "sendBeforeReceiving": "Send indkøbsordren, før du modtager varer på den.",
      "orderCancelled": "Indkøbsordren er annulleret.",
      "lineNotOnOrder": "En af linjerne findes ikke på ordren.",
      "negativeReceipt": "Der kan ikke modtages færre end nul.",
      "barcodeRequired": "Indtast eller scan en stregkode.",
      "barcodeNotOnOrder": "Stregkoden står ikke på denne indkøbsordre.",
      "alreadyReceived": "Indkøbsordren er allerede modtaget."
    },
    "columns": {
      "product": "Vare",
      "waiting": "Kunder venter",
      "stock": "Lager",
      "incoming": "På vej",
      "order": "Bestil",
      "cost": "Kostpris"
    },
    "status": {
      "Draft": "Kladde",
      "Ordered": "Bestilt",
      "PartiallyReceived": "Delvist modtaget",
      "Received": "Modtaget",
      "Cancelled": "Annulleret"
    },
    "weekday": {
      "Monday": "Mandag",
      "Tuesday": "Tirsdag",
      "Wednesday": "Onsdag",
      "Thursday": "Torsdag",
      "Friday": "Fredag",
      "Saturday": "Lørdag",
      "Sunday": "Søndag"
    },
    "weekdayShort": {
      "Monday": "Man",
      "Tuesday": "Tir",
      "Wednesday": "Ons",
      "Thursday": "Tor",
      "Friday": "Fre",
      "Saturday": "Lør",
      "Sunday": "Søn"
    },
    "orders": {
      "title": "Indkøbsordrer",
      "subtitle": "Bestillinger hos leverandører og status på leveringen.",
      "toSuggestions": "Til indkøbsforslag",
      "loadFailed": "Kunne ikke hente indkøbsordrer.",
      "openOnly": "Kun åbne",
      "empty": "Ingen indkøbsordrer.",
      "columns": {
        "number": "Nummer",
        "supplier": "Leverandør",
        "status": "Status",
        "ordered": "Bestilt",
        "expected": "Forventet",
        "received": "Modtaget",
        "cost": "Kostpris"
      }
    },
    "detail": {
      "back": "Tilbage til indkøbsordrer",
      "loadFailed": "Kunne ikke hente indkøbsordren.",
      "reference": "ref. {reference}",
      "downloadCsv": "Hent CSV",
      "markOrdered": "Markér som bestilt",
      "markedOrdered": "Indkøbsordren er markeret som bestilt",
      "receiveAll": "Modtag alt",
      "allReceived": "Hele leveringen er modtaget",
      "lineReceived": "{name}: {change} stk.",
      "scanReceived": "{ean} modtaget",
      "cancelTitle": "Annullér indkøbsordre",
      "cancelBody": "Den forventede leveringsdato fjernes fra varerne, så kundeordrer ikke fortsat lover en dato der ikke kommer.",
      "cancelConfirm": "Annullér ordren",
      "cancelled": "Indkøbsordren er annulleret",
      "overdue": "Leveringen er forsinket — forventet {date}.",
      "receivedSummary": "{count} stk. modtaget",
      "expectedOn": "forventet {date}",
      "orderedAt": "bestilt {date}",
      "scanLabel": "Scan stregkode for at modtage",
      "barcode": "Stregkode",
      "receiveOne": "Modtag 1 stk.",
      "lines": "Varelinjer",
      "pickLocation": "plads {location}",
      "shortOnOrders": "{count} stk. mangler til kundeordrer",
      "complete": "Komplet",
      "receiveCount": "Modtag {count}",
      "outstanding": "{count} mangler",
      "figures": {
        "ordered": "Bestilt",
        "received": "Modtaget",
        "inStock": "På lager"
      },
      "details": "Detaljer",
      "fields": {
        "created": "Oprettet",
        "ordered": "Bestilt",
        "expected": "Forventet",
        "completed": "Afsluttet",
        "totalCost": "Kostpris i alt"
      },
      "note": "Note",
      "saveNote": "Gem note",
      "noteSaved": "Noten er gemt",
      "noteSaveFailed": "Noten blev ikke gemt",
      "sendIntro": "Den forventede dato sættes på varerne, så kundeordrer der venter, viser en rigtig leveringsdato i stedet for \"mangler bestilling\".",
      "expectedDelivery": "Forventet levering",
      "supplierReference": "Leverandørens reference"
    }
  },
  "campaigns": {
    "title": "Mailforslag",
    "subtitle": "Fem konkrete kampagneforslag, skrevet ud fra hvad butikken selv har sendt før, hvad der solgte i perioden, og hvad I sagde om sidste omgang.",
    "errors": {
      "noGenerator": "Der er ikke sat en sprogmodel op til at skrive forslag. Uden den kan der ikke genereres noget.",
      "periodBackwards": "Slutdatoen ligger før startdatoen.",
      "noCandidates": "Ingen varer kan vises i en kampagne — de mangler billede eller er ikke på lager.",
      "nothingGenerated": "Der kom ingen forslag tilbage.",
      "monthlyLimit": "Arbejdsområdet har brugt sin andel af forslag denne måned. Grænsen findes for at én ivrig eftermiddag ikke kan bruge platformens konto, før nogen opdager det.",
      "noKlaviyo": "Der er ingen Klaviyo-konto på arbejdsområdet.",
      "notFound": "Forslaget findes ikke."
    },
    "generate": "Lav forslag",
    "generating": "Skriver …",
    "periodFrom": "Periode fra",
    "periodTo": "Periode til",
    "theme": "Tema",
    "themeHint": "Valgfrit. Fx \"sommerudsalg\" eller \"nye ridehjelme\".",
    "periodHint": "Typisk de samme uger sidste år — det er dér, sæsonen ligner sig selv.",
    "loadFailed": "Kunne ikke hente forslagene.",
    "generateFailed": "Kunne ikke lave forslag.",
    "empty": "Ingen forslag endnu.",
    "active": "Aktive",
    "archive": "Arkiv",
    "batch": "Omgang {date}",
    "basedOn": "Bygget på {name}",
    "subjectOptions": "Emnelinjer",
    "previewOptions": "Forhåndsvisning",
    "products": "Varer i mailen",
    "feedback": "Hvad I kan lide ved den",
    "feedbackHint": "Det her bliver sendt med næste gang, som eksempel på jeres tone. Det er dét, der gør forslagene bedre over tid.",
    "approve": "Godkend",
    "approved": "Godkendt",
    "archiveIt": "Arkivér",
    "saveFailed": "Kunne ikke gemme.",
    "status": {
      "Draft": "Udkast",
      "Approved": "Godkendt",
      "SentToKlaviyo": "Sendt til Klaviyo",
      "Discarded": "Kasseret"
    },
    "type": {
      "ReuseTop": "Genbrug den bedste",
      "ReworkSamePeriod": "Samme periode, omskrevet",
      "ProductHighlight": "Enkelt vare",
      "CategoryCampaign": "Kategori",
      "SaleCampaign": "Udsalg",
      "Seasonal": "Sæson",
      "AiVariant": "Variant"
    },
    "klaviyo": {
      "title": "Klaviyo",
      "subtitle": "Butikkens egen konto — hver butik har sin egen liste, sin egen historik og sin egen regning. Nøglen vises aldrig igen; lad feltet stå tomt for at beholde den, der er gemt.",
      "apiKey": "API-nøgle",
      "alreadySet": "Der er en nøgle gemt",
      "save": "Gem",
      "saved": "Gemt",
      "test": "Afprøv",
      "sync": "Hent kampagner",
      "synced": "{created} nye og {updated} opdaterede kampagner",
      "lastSync": "Sidst hentet {when} — {count} kampagner."
    },
    "settings": {
      "title": "Sådan skriver vi",
      "subtitle": "Butikkens egen stemme. Læses ordret, hver gang der laves forslag — og et forslag skrevet uden den lyder som alle andre butikkers.",
      "saved": "Gemt",
      "brandName": "Butiksnavn",
      "senderName": "Afsendernavn",
      "senderEmail": "Afsenderadresse",
      "language": "Sprog",
      "toneOfVoice": "Tone",
      "targetAudience": "Målgruppe",
      "greetingStyle": "Tiltale",
      "signature": "Underskrift",
      "emojiUsage": "Emoji",
      "subjectStyle": "Emnelinjer",
      "ctaStyle": "Handlingsknap",
      "doList": "Gør",
      "dontList": "Undgå",
      "discountPolicy": "Rabatpolitik",
      "preferredSendDays": "Bedste sendedage",
      "extraNotes": "Andet",
      "readStyle": "Læs stemmen fra tidligere kampagner",
      "readStyleHint": "Læst ud af {count} tidligere kampagner. Forslagene beskriver, hvordan butikken har skrevet — ikke hvordan den skal.",
      "tooFewCampaigns": "Der er kun {count} tidligere kampagner. Der skal mindst {minimum} til, før et mønster siger noget.",
      "use": "Brug denne"
    },
    "pdf": "Hent som PDF",
    "pdfFailed": "PDF-filen kunne ikke laves.",
    "basedOnShort": "Bygget på",
    "voiceEmpty": "Butikkens stemme er ikke udfyldt endnu, så forslagene bliver skrevet for en butik i almindelighed frem for for jer. Udfyld den under"
  },
  "platform": {
    "title": "Drift",
    "subtitle": "Butikkens data: tøm eller eksportér. Kun for superadministrator.",
    "workspace": "Butik",
    "members": "Brugere",
    "created": "Oprettet",
    "name": "Navn",
    "loadFailed": "Kunne ikke hente butikken.",
    "empty": "Tøm",
    "emptyTitle": "Tøm {name}",
    "emptyWarning": "Sletter varer, kunder, ordrer, leverandører, indkøb, abonnementer og beskedloggen. Det kan ikke fortrydes.",
    "emptyKeeps": "Butikken består: brugere, roller, indstillinger, momsopsætning, beskedskabeloner, egne ord, fragtregler og adgangsoplysninger til fragt og kanaler.",
    "emptyConfirm": "Skriv {slug} for at bekræfte",
    "emptied": "Tømt — {count} rækker slettet.",
    "emptyFailed": "Butikken kunne ikke tømmes.",
    "export": "Eksportér",
    "errors": {
      "unknownSetting": "Ukendt indstilling."
    }
  },
  "integrations": {
    "title": "Opkoblinger",
    "subtitle": "Hvad der skal kobles på, hvor det sættes, og hvad der mangler. Værdierne vises aldrig — kun om der er en.",
    "platform": "Platformens egne konti",
    "platformHint": "Én konto for alle butikker. Sættes uden for databasen, så ingen skærm — og ingen kundes administrator — kan læse eller ændre den.",
    "tenant": "Butikkens egne konti",
    "tenantHint": "Hver butik har sin egen. Sættes på skærmen for det arbejdsområde, det gælder.",
    "tabs": {
      "platform": "Platformen",
      "shops": "Butikker",
      "shipping": "Fragt",
      "marketing": "Marketing",
      "overview": "Oversigt"
    },
    "listModels": "Hent modeller",
    "chooseModel": "Vælg model",
    "saveKeyFirst": "Gem API-nøglen først",
    "save": "Gem",
    "clear": "Ryd",
    "saved": "Gemt",
    "saveFailed": "Kunne ikke gemme.",
    "fromScreen": "Indtastet her",
    "fromConfiguration": "Kommer fra konfigurationen — indtast her for at overskrive.",
    "stillInConfig": "To ting kan ikke flyttes herind: certifikatet til nøgleringen, fordi det beskytter dét, der ville beskytte disse felter, og listen over platformadministratorer, fordi den afgør hvem der må se denne side. Begge sættes i konfigurationen.",
    "group": {
      "openAi": "OpenAI",
      "mail": "Udgående mail",
      "general": "Generelt"
    },
    "groupHint": {
      "openAi": "Skriver kampagne- og produktforslag. Én konto for alle butikker; forbruget registreres pr. forslag.",
      "mail": "Sender al udgående post. Uden en nøgle bliver beskeder skrevet i loggen og ikke sendt.",
      "general": "Gælder hele installationen."
    },
    "setting": {
      "OpenAi:ApiKey": "API-nøgle",
      "OpenAi:Model": "Model",
      "OpenAi:MonthlyBatchesPerTenant": "Omgange pr. arbejdsområde pr. måned",
      "OpenAi:MonthlyProductOptimizationsPerTenant": "Produktforslag pr. arbejdsområde pr. måned",
      "Mail:Mandrill:ApiKey": "Mandrill API-nøgle",
      "Mail:SenderEmail": "Standardafsender",
      "Mail:SenderName": "Afsendernavn",
      "PublicUrl": "Offentlig adresse"
    },
    "settingHint": {
      "OpenAi:ApiKey": "Virker med det samme — ingen genstart.",
      "OpenAi:Model": "Modeller hentes automatisk med den gemte API-nøgle. Vælg en model, og tryk Gem.",
      "OpenAi:MonthlyBatchesPerTenant": "Værn mod en løbsk eftermiddag, ikke et budget. 0 fjerner grænsen.",
      "OpenAi:MonthlyProductOptimizationsPerTenant": "Separat forbrugsgrænse for produkttekster. 0 fjerner grænsen.",
      "Mail:Mandrill:ApiKey": "Domænet skal verificeres pr. butik — Mandrill tager imod mail fra et uverificeret domæne og lægger den i spam.",
      "Mail:SenderEmail": "Bruges når et arbejdsområde ikke selv har sat en afsender.",
      "Mail:SenderName": "Navnet der står i modtagerens indbakke.",
      "PublicUrl": "Adressen der står i links i mails. Uden den bliver de tomme."
    },
    "configured": "Sat",
    "missing": "Mangler",
    "notBuilt": "Ikke bygget endnu",
    "setIn": "Sættes i",
    "open": "Åbn skærmen",
    "loadFailed": "Kunne ikke hente opkoblingerne.",
    "howTo": "Sæt en værdi med brugerhemmeligheder lokalt, eller som miljøvariabel i drift. Kolon bliver til dobbelt understreg i en miljøvariabel.",
    "name": {
      "openAi": "OpenAI",
      "mandrill": "Mandrill",
      "publicUrl": "Offentlig adresse",
      "dataProtection": "Certifikat til nøgleringen",
      "forwardedHeaders": "Load balancer",
      "shopify": "Shopify",
      "dandomain": "Dandomain",
      "shipmondo": "Shipmondo",
      "supplierFeeds": "Leverandørfeeds",
      "klaviyo": "Klaviyo",
      "onpay": "OnPay"
    },
    "what": {
      "openAi": "Skriver kampagneforslag og forslag til produkttekster.",
      "mandrill": "Sender al udgående mail. Domænet skal verificeres pr. butik.",
      "publicUrl": "Adressen der står i links i mails. Uden den bliver de tomme.",
      "dataProtection": "Krypterer nøgleringen, som krypterer alle credentials i databasen. Uden den er databaseadgang lig credential-adgang.",
      "forwardedHeaders": "Hvilke proxyer der må sætte klientens IP. Uden den kan underdomænet ikke afgøre arbejdsområdet bag en load balancer.",
      "shopify": "Butik, ordrer og varekatalog.",
      "dandomain": "Kun til migrering — engangs- og deltaimport.",
      "shipmondo": "Fragtaftaler og labels.",
      "supplierFeeds": "Automatisk hentning af pris- og lagerfiler.",
      "klaviyo": "Kampagnehistorik og kladder. Nøglen sættes på Mailforslag.",
      "onpay": "Abonnementsbetalinger. Mangler at blive bygget."
    }
  },
  "pim": {
    "title": "Leverandørkatalog",
    "subtitle": "Leverandørernes egne varestamdata. Ét produkt er én stil i én farve; varianterne er størrelserne. Intet bliver slettet, fordi det mangler i en fil.",
    "errors": {
      "notFound": "Produktet findes ikke.",
      "noFormat": "Leverandøren har ikke fået sat et katalogformat. Vælg et på leverandøren, før du henter en fil ind.",
      "noParser": "Der findes ingen indlæser til det format.",
      "noVariants": "Produktet har ingen varianter og kan ikke lægges i shoppen.",
      "noApprovedCategory": "Produktets kategori er ikke godkendt endnu. Godkend den under Kategorier, før du lægger varen i shoppen.",
      "noShopConnection": "Der er ingen Shopify-forbindelse på arbejdsområdet.",
      "categoryNotFound": "Kategorien findes ikke.",
      "alreadyRunning": "Der kører allerede en overførsel."
    },
    "empty": "Ingen varer endnu. Indlæs en katalogfil fra leverandøren.",
    "loadFailed": "Kunne ikke hente kataloget.",
    "columns": {
      "product": "Vare",
      "color": "Farve",
      "sizes": "Størrelser",
      "images": "Billeder",
      "category": "Kategori",
      "status": "Status",
      "path": "Leverandørens kategori",
      "products": "Produkter",
      "shopCategory": "Kategori i shoppen",
      "brandCategory": "Mærkekategori",
      "file": "Fil",
      "result": "Resultat",
      "started": "Startet"
    },
    "supplier": "Leverandør",
    "chooseSupplier": "Vælg leverandør",
    "noSuppliers": "Ingen leverandører har et katalogformat endnu. Sæt et på leverandøren først.",
    "import": "Indlæs katalogfil",
    "importing": "Indlæser …",
    "importDone": "Filen er indlæst",
    "importFailed": "Kunne ikke indlæse filen.",
    "search": "Søg på navn eller varenummer",
    "allStatuses": "Alle",
    "job": {
      "queueDryRun": "Tørløb på {count} valgte",
      "queueLive": "Læg {count} valgte i shoppen",
      "queued": "Sat i kø",
      "queueFailed": "Kunne ikke sætte i kø.",
      "progress": "{done} af {total}",
      "running": "Kører",
      "cancel": "Stop",
      "cancelling": "Stopper efter den vare, den er i gang med",
      "dryRunLabel": "Tørløb",
      "note": "Kører videre i baggrunden — du kan roligt lukke siden.",
      "status": {
        "Queued": "I kø",
        "Running": "Kører",
        "Completed": "Færdig",
        "CompletedWithErrors": "Færdig med fejl",
        "Cancelled": "Stoppet",
        "Failed": "Fejlet"
      }
    },
    "detail": {
      "noImages": "Ingen billeder — varen bliver lagt i shoppen uden.",
      "mainItem": "Stilnummer",
      "origin": "Oprindelsesland",
      "itemcode": "Varenummer",
      "ean": "Stregkode",
      "weight": "Vægt",
      "purchasePrice": "Indkøbspris",
      "retailPrice": "Vejl. udsalgspris",
      "ownCategory": "Egen kategori for denne vare",
      "ownCategoryHint": "Slår igennem uanset hvad leverandørens kategori peger på — beslutningen her er taget mens man kiggede på netop denne vare."
    },
    "mapping": {
      "title": "Hvor leverandørens kategorier lander",
      "subtitle": "Beslutningen tages pr. kategori, ikke pr. vare. Der bliver ikke lagt noget i shoppen, før kategorien er godkendt.",
      "manual": "Enkelt vare",
      "choose": "Vælg kategori",
      "declineBrand": "Ingen mærkekategori",
      "pdf": "Hent PDF",
      "pdfFailed": "Kunne ikke lave PDF.",
      "basedOnShort": "Bygget på",
      "approve": "Godkend",
      "save": "Gem som forslag",
      "suggest": "Foreslå ud fra butikken",
      "suggested": "{paths} kategorier fik et forslag ud fra {recognised} af {total} varer, som butikken allerede sælger. {kept} blev ladt i fred, fordi nogen allerede havde besluttet.",
      "suggestedFromStyle": "{count} varer, butikken ikke sælger, fik forslag fra andre farver af samme stil.",
      "readStyle": "Læs af tidligere kampagner",
      "readStyleHint": "Læst af {count} sendte kampagner. Det er tal, ikke vurderinger — tone og målgruppe kan kun læses af en sprogmodel, og den er ikke sat op endnu.",
      "tooFewCampaigns": "Der er {count} kampagner at læse af, og der skal mindst {minimum} til. Kampagner hentes fra Klaviyo, som ikke er koblet på endnu.",
      "use": "Brug",
      "saved": "Gemt",
      "saveFailed": "Kunne ikke gemme kategorien.",
      "status": {
        "Suggested": "Forslag",
        "Approved": "Godkendt",
        "Rejected": "Fravalgt"
      },
      "none": "Ikke valgt"
    },
    "publish": {
      "dryRun": "Tørløb",
      "live": "Læg i shoppen",
      "running": "Arbejder …",
      "heading": "Resultat",
      "dryRunNote": "Tørløb skriver ingenting — hverken i shoppen eller her.",
      "action": {
        "Created": "Oprettes",
        "Updated": "Opdateres",
        "Failed": "Fejlede"
      },
      "actionDone": {
        "Created": "Oprettet",
        "Updated": "Opdateret",
        "Failed": "Fejlede"
      },
      "variantsCreated": "{count} størrelser oprettes",
      "variantsUpdated": "{count} størrelser opdateres",
      "imagesAdded": "{count} billeder lægges op",
      "failed": "Kunne ikke lægge varen i shoppen."
    },
    "tabs": {
      "products": "Produkter",
      "categories": "Kategorier",
      "imports": "Importer"
    },
    "status": {
      "New": "Ny",
      "Published": "Udgivet",
      "Rejected": "Fravalgt"
    }
  },
  "suppliers": {
    "title": "Leverandører",
    "subtitle": "Hvem varerne bestilles hos, hvornår der bestilles, og hvor lang leveringstiden er.",
    "back": "Tilbage til leverandører",
    "newSupplier": "Ny leverandør",
    "editSupplier": "Redigér leverandør",
    "loadFailed": "Kunne ikke hente leverandører.",
    "loadOneFailed": "Kunne ikke hente leverandøren.",
    "saved": "Leverandøren er gemt",
    "deleteTitle": "Slet leverandør",
    "deleteBody": "Slet \"{name}\"? Det kan kun lade sig gøre, hvis der hverken er varer eller indkøbsordrer på den.",
    "deleted": "Leverandøren er slettet",
    "deleteFailed": "Kunne ikke slette",
    "empty": "Ingen leverandører endnu. Opret den første for at kunne bestille varer hjem.",
    "inactive": "Inaktiv",
    "wholesalerBrands": "Grossist · {count} mærker",
    "orderedThrough": "Bestilles gennem {name}",
    "noEmail": "Ingen e-mail",
    "customerNumber": "kundenr. {number}",
    "productCount": "{count} varer",
    "lastImported": "sidst importeret {date}",
    "priceFile": "Prisfil",
    "configured": "Opsat",
    "notConfigured": "Ikke opsat",
    "orderedDirectly": "Bestilles direkte",
    "isWholesalerHint": "Denne leverandør er selv grossist for andre mærker og kan derfor ikke lægges under en.",
    "wholesalerHint": "Vælges en grossist, samles varer fra alle deres mærker på én bestilling, og bestillingen sendes til grossistens e-mail.",
    "orderDaysHint": "Bruges til at markere leverandøren på indkøbslisten den rigtige dag.",
    "pimFormatHint": "Kun for leverandører der sender et varekatalog. Formatet vælger, hvilken indlæser der læser filen under Leverandørkatalog.",
    "costPriceFactorHint": "Kostpriser fra filen ganges med denne — 7,45 for euro, 0,9 for 10 % rabat. Resultatet gemmes altid i workspacets egen valuta.",
    "invoicesInCurrency": "{name} fakturerer i {currency}",
    "currencyWithoutFactor": "{invoices}, men omregningsfaktoren er 1. Kostpriserne bliver gemt som tal uden omregning, og alle avancer bygget på dem bliver forkerte. Sæt faktoren, eller ryd valutaen.",
    "columns": {
      "name": "Navn",
      "orderDays": "Bestillingsdage",
      "leadTime": "Leveringstid",
      "minimumOrder": "Minimumskøb",
      "products": "Produkter",
      "priceFile": "Prisfil"
    },
    "fields": {
      "pimFormat": "Katalogformat",
      "noPimFormat": "Sender intet katalog",
      "name": "Navn",
      "wholesaler": "Købes gennem grossist",
      "email": "E-mail til bestillinger",
      "contactName": "Kontaktperson",
      "orderDays": "Bestillingsdage",
      "leadTime": "Leveringstid (dage)",
      "minimumOrder": "Minimumskøb",
      "currency": "Fakturerer i",
      "costPriceFactor": "Kostprisfaktor",
      "ourCustomerNumber": "Vores kundenummer",
      "note": "Note",
      "active": "Aktiv"
    },
    "importStatus": {
      "Running": "Kører",
      "Completed": "Gennemført",
      "CompletedWithWarnings": "Gennemført med advarsler",
      "Failed": "Fejlet"
    },
    "import": {
      "title": "Indlæs prisfil",
      "mappingIncomplete": "Udfyld filopsætningen til højre først — mindst varenummer eller stregkode, og enten kostpris eller lager.",
      "chooseFile": "Vælg fil",
      "hint": "CSV, TSV eller Excel. Kostpriser ganges med faktor {factor}.",
      "hintWithCurrency": "CSV, TSV eller Excel. Kostpriser ganges med faktor {factor} og gemmes i workspacets valuta.",
      "failed": "Importen mislykkedes.",
      "runFailed": "Importen fejlede",
      "fileRead": "Filen er indlæst",
      "summary": "{rows} rækker · {matched} matchet · {prices} kostpriser opdateret",
      "runSummary": "{rows} rækker · {matched} matchet · {prices} priser",
      "rowsRead": "{count} rækker læst",
      "rowsCreated": "{count} nye",
      "rowsUpdated": "{count} opdateret",
      "rowsMatched": "{count} matchet mod kataloget",
      "pricesChanged": "{count} kostpriser ændret",
      "rowsSkipped": "{count} sprunget over",
      "rowsDelisted": "{count} udgået",
      "warnings": "{count} advarsler",
      "history": "Tidligere importer",
      "noHistory": "Ingen importer endnu."
    },
    "mapping": {
      "title": "Filopsætning",
      "saved": "Filopsætningen er gemt",
      "fileType": "Filtype",
      "delimiter": "Skilletegn",
      "sheetNumber": "Ark nr.",
      "skipRows": "Overspring rækker",
      "columnsHint": "Kolonner tælles fra 1 — kolonne A er 1. Tomme felter springes over.",
      "sku": "Varenummer",
      "ean": "Stregkode",
      "name": "Navn",
      "extraColumn": "+ kolonne",
      "costPrice": "Kostpris",
      "retailPrice": "Vejl. udsalg",
      "stock": "Lager",
      "inStockValue": "\"På lager\"-værdi",
      "inStockPlaceholder": "fx Ja",
      "inStockHint": "Udfyld kun \"på lager\"-værdien, hvis lagerkolonnen indeholder et ord i stedet for et antal.",
      "decimalMark": "Decimaltegn",
      "trimCharacters": "Fjern tegn fra celler",
      "trimPlaceholder": "fx \"",
      "save": "Gem filopsætning",
      "format": {
        "Delimited": "Tekstfil (CSV, TSV)",
        "Excel": "Excel (.xlsx)"
      },
      "decimal": {
        "Comma": "Komma — 1.234,56",
        "Point": "Punktum — 1,234.56"
      }
    },
    "catalogue": {
      "title": "Leverandørens katalog",
      "unmatchedOnly": "Kun uden match",
      "empty": "Ingen rækker endnu. Indlæs en prisfil ovenfor.",
      "noMatch": "Intet match",
      "inStock": "På lager",
      "outOfStock": "Ikke på lager",
      "unknownStock": "Ukendt",
      "delisted": "Udgået",
      "columns": {
        "supplierProduct": "Leverandørens vare",
        "match": "Match",
        "costPrice": "Kostpris",
        "atSupplier": "Hos leverandør"
      }
    },
    "feeds": {
      "title": "Automatiske filhentninger",
      "intro": "Hentes automatisk hver nat kl. 05.15 og køres gennem den samme import som en fil, du selv lægger op.",
      "newFeed": "Nyt feed",
      "editFeed": "Redigér feed",
      "empty": "Ingen automatiske hentninger. Filer skal indlæses manuelt.",
      "loadFailed": "Kunne ikke hente feeds.",
      "saved": "Feedet er gemt",
      "deleteTitle": "Slet feed",
      "deleteBody": "Slet \"{name}\"? Allerede importerede priser bevares.",
      "fetchNow": "Hent nu",
      "importedDetail": "{matched} matchede kataloget · {prices} kostpriser ændret",
      "unchanged": "Filen er uændret",
      "unchangedDetail": "Leverandøren har ikke lagt en ny fil op siden sidst.",
      "fetchFailed": "Kunne ikke hentes",
      "parseFailed": "Kunne ikke læses",
      "runFailed": "Kørslen kunne ikke startes.",
      "namePlaceholder": "fx Prisliste",
      "urlPlaceholder": "https://priser.eksempel.dk",
      "serverPlaceholder": "ftp.eksempel.dk",
      "passwordUnchanged": "Uændret",
      "fileSection": "Filens opbygning",
      "columnsHint": "Kolonnenumre som i regnearket: kolonne A er 1. Lad stå tomt hvis filen ikke har kolonnen.",
      "inStockWord": "Ord der betyder \"på lager\"",
      "inStockHint": "Kun hvis lagerkolonnen indeholder ord i stedet for et antal.",
      "fetchNightly": "Hent automatisk hver nat",
      "mappingIncomplete": "Angiv mindst varenummer eller stregkode, og enten kostpris eller lager — ellers kan filen ikke bruges til noget.",
      "columns": {
        "feed": "Feed",
        "status": "Status",
        "lastFetched": "Sidst hentet"
      },
      "fields": {
        "name": "Navn",
        "transport": "Forbindelse",
        "url": "Adresse",
        "server": "Server",
        "port": "Port",
        "remotePath": "Sti til filen",
        "username": "Brugernavn",
        "password": "Adgangskode"
      },
      "status": {
        "off": "Slået fra",
        "incomplete": "Mangler opsætning",
        "neverRun": "Ikke kørt endnu",
        "ok": "OK",
        "failed": "Fejlede"
      },
      "errors": {
        "nameRequired": "Navn er påkrævet.",
        "hostRequired": "Angiv en server eller adresse.",
        "remotePathRequired": "Angiv stien til filen.",
        "portRange": "Port skal være mellem 0 og 65535."
      },
      "pathPlaceholder": "/export/priser.csv"
    },
    "errors": {
      "notFound": "Leverandøren findes ikke.",
      "mappingUnusable": "Leverandøren mangler en filopsætning. Angiv mindst varenummer eller stregkode, og enten kostpris eller lager.",
      "nameRequired": "Navn er påkrævet.",
      "nameTaken": "Der findes allerede en leverandør med det navn.",
      "leadTimeRange": "Leveringstid skal være mellem 0 og 365 dage.",
      "weekdayInvalid": "Ugyldig ugedag.",
      "hasPurchaseOrders": "Leverandøren har indkøbsordrer. Deaktivér den i stedet.",
      "hasProducts": "Leverandøren er tilknyttet varer. Flyt dem først.",
      "wholesalerNotFound": "Grossisten findes ikke.",
      "wholesalerIsSelf": "En leverandør kan ikke købes gennem sig selv.",
      "wholesalerHasParent": "Den valgte grossist købes selv gennem en grossist og kan derfor ikke være grossist.",
      "supplierHasBrands": "Denne leverandør har selv mærker under sig og kan derfor ikke lægges under en grossist.",
      "fileEmpty": "Filen er tom.",
      "fileTooLarge": "Filen er større end 32 MB."
    }
  },
  "subscriptions": {
    "title": "Abonnementer",
    "subtitle": "Faste leveringer. Hvert træk bliver til en almindelig ordre i pakkelisten.",
    "simulatedTitle": "Betalinger er simulerede.",
    "simulatedBody": "Betalingsløsningen \"{gateway}\" trækker ingen penge — abonnementstræk opretter ordrer, men der bliver ikke betalt. Tilslut en rigtig betalingsløsning før idriftsættelse.",
    "failedAttempts": "{count} mislykkede forsøg",
    "nextColumn": "Næste",
    "customerColumn": "Kunde",
    "empty": "Ingen abonnementer.",
    "loadFailed": "Kunne ikke hente abonnementer.",
    "searchPlaceholder": "Reference, kunde eller e-mail",
    "tiles": {
      "active": "Aktive",
      "perMonth": "{amount} pr. måned",
      "overdue": "Forfaldne",
      "overdueHint": "Skulle have været trukket",
      "dueSoon": "Inden for 7 dage",
      "dueSoonHint": "Sendes snart",
      "failedHint": "Skal følges op"
    },
    "payments": {
      "ourRuns": "smibos træk",
      "atGateway": "Hos udbyderen",
      "noRuns": "Ingen træk endnu.",
      "amountColumn": "Beløb",
      "gatewayNotLive": "Betalingsudbyderen er ikke koblet på endnu ({gateway}). Der er ikke trukket rigtige penge, og der er ingen transaktioner at hente.",
      "gatewayNoHistory": "{gateway} kan ikke spørges om historik herfra.",
      "loadFailed": "Kunne ikke hente betalinger.",
      "orderLabel": "Ordre",
      "noAgreement": "Der er ingen betalingsaftale på abonnementet, så der er intet at hente.",
      "referenceColumn": "Reference"
    },
    "intervalMonthly": "Hver måned",
    "intervalEveryNMonths": "Hver {count}. måned",
    "status": {
      "Active": "Aktivt",
      "Paused": "På pause",
      "PaymentFailed": "Betaling fejlede",
      "Cancelled": "Annulleret",
      "PendingPayment": "Mangler betalingsaftale"
    },
    "runOutcome": {
      "Delivered": "Leveret",
      "PaymentDeclined": "Betaling afvist",
      "CardExpired": "Kort udløbet",
      "NothingToShip": "Intet at sende",
      "Error": "Fejl"
    },
    "anchor": {
      "Rolling": "Løbende",
      "CalendarMonth": "Den 1. i måneden"
    },
    "anchorHint": {
      "Rolling": "Næste levering er N måneder efter den forrige.",
      "CalendarMonth": "Alle abonnenter sendes samtidig, uanset hvornår de startede."
    }
  },
  "confirmSignUp": {
    "title": "Bekræft din tilmelding",
    "lead": "Bekræft, at det er dig, der har tilmeldt dig {plan}. Der trækkes ingen penge — vi kontakter dig om betaling bagefter.",
    "expiredTitle": "Linket virker ikke længere",
    "expiredBody": "Det er enten forkert, allerede brugt, eller mere end syv dage gammelt. Udfyld tilmeldingen igen, så sender vi et nyt link.",
    "doneTitle": "Tak — du er tilmeldt",
    "doneBody": "Din tilmelding er registreret under {reference}, og vi har sendt en bekræftelse på e-mail.",
    "notActiveYet": "Abonnementet er endnu ikke aktivt. Vi kontakter dig om betaling, og første levering sendes tidligst {date}.",
    "manageHere": "Du kan se og ændre dit abonnement her:",
    "deliveredTo": "Leveres til",
    "earliest": "Første levering sendes tidligst {date}.",
    "confirmButton": "Ja, det er mig — tilmeld mig",
    "notYou": "Har du ikke tilmeldt dig? Så luk bare siden — der sker ikke mere.",
    "failed": "Bekræftelsen kunne ikke gennemføres. Prøv igen om lidt."
  },
  "portal": {
    "loadFailed": "Siden kunne ikke hentes lige nu. Prøv igen om lidt.",
    "actionFailed": "Det kunne ikke lade sig gøre.",
    "expiredTitle": "Linket virker ikke længere",
    "expiredBody": "Det kan være, at abonnementet er opsagt, eller at linket er blevet erstattet af et nyere. Skriv til os, så finder vi ud af det.",
    "paymentFailedBody": "Vi kunne ikke trække betalingen. Skriv til os, så sender vi et link til at forny kortet.",
    "nextDelivery": "Næste levering",
    "cardExpires": "Kort udløber",
    "skipNext": "Spring næste levering over",
    "skipped": "Næste levering er sprunget over.",
    "pause": "Sæt på pause",
    "paused": "Dit abonnement er sat på pause.",
    "contactUs": "Vil du ændre hvad der er i kassen, eller hvor ofte det kommer? Skriv til os — så ordner vi det.",
    "street2": "Etage, dør m.m.",
    "cancelReason": "Må vi spørge hvorfor? (frivilligt)",
    "title": "Dit abonnement",
    "addressSaveFailed": "Adressen kunne ikke gemmes.",
    "cancelled": "Dit abonnement er opsagt. Du modtager ikke flere leveringer.",
    "resumed": "Dit abonnement er genoptaget.",
    "cancelTitle": "Opsig abonnement",
    "cancelBody": "Du modtager ikke flere leveringer, og der bliver ikke trukket flere betalinger. Du kan altid tegne et nyt.",
    "intervalMonthly": "Hver måned",
    "intervalQuarterly": "Hvert kvartal",
    "intervalYearly": "En gang om året",
    "intervalEveryNMonths": "Hver {count}. måned",
    "status": {
      "Active": "Aktivt",
      "Paused": "På pause",
      "PaymentFailed": "Betaling mislykkedes",
      "Cancelled": "Opsagt",
      "PendingPayment": "Afventer oprettelse"
    },
    "resume": "Genoptag",
    "editAddress": "Ret adresse",
    "cancel": "Opsig",
    "editAddressTitle": "Ret leveringsadresse",
    "keepIt": "Behold abonnementet"
  },
  "plans": {
    "title": "Abonnementer til salg",
    "subtitle": "Det kunderne kan tegne selv. Hvert offentliggjort abonnement har et link, du kan lægge på hjemmesiden.",
    "newPlan": "Nyt abonnement",
    "editPlan": "Redigér abonnement",
    "empty": "Ingen abonnementer endnu. Opret ét for at kunne tage imod tilmeldinger.",
    "loadFailed": "Kunne ikke hente abonnementerne.",
    "saved": "Abonnementet er gemt",
    "linkCopied": "Link kopieret",
    "copyFailed": "Kunne ikke kopiere",
    "planColumn": "Abonnement",
    "signUpsColumn": "Tilmeldte",
    "linkColumn": "Link",
    "published": "Offentliggjort",
    "draft": "Kladde",
    "notPublished": "Ikke offentliggjort",
    "needsPublicUrl": "Sæt Smibo:PublicUrl for at få et link",
    "copyLink": "Kopiér link",
    "lineCount": "{count} varelinjer",
    "name": "Navn",
    "description": "Beskrivelse",
    "descriptionHint": "vises på tilmeldingssiden",
    "everyNMonths": "Hver … måned",
    "shipping": "Fragt pr. levering",
    "deliveryMethod": "Leveringsmåde",
    "leadTime": "Første levering om",
    "days": "dage",
    "contents": "Indhold",
    "noProducts": "Ingen varer valgt endnu.",
    "addProduct": "Tilføj vare",
    "productSearch": "Søg på varenummer eller navn",
    "noPrice": "ingen pris",
    "publishedHint": "Offentliggjort — linket virker, og kunder kan tilmelde sig",
    "anchorRolling": "N måneder efter sidste levering",
    "anchorCalendar": "Den 1. i måneden — alle sendes samtidig",
    "pricePlaceholder": "Varens pris"
  },
  "subscriptionDetail": {
    "linkCopiedHint": "Indsæt det i en mail til kunden.",
    "linkFailed": "Kunne ikke hente linket",
    "loadFailed": "Kunne ikke hente abonnementet.",
    "paused": "Sat på pause",
    "skipped": "Næste levering sprunget over",
    "runNowTitle": "Kør trækket nu",
    "runNowBody": "Abonnementet trækkes og der oprettes en ordre med det samme, uden at vente på det natlige job.",
    "runNow": "Kør nu",
    "ranNow": "Trækket er kørt",
    "cancelTitle": "Annullér abonnement",
    "cancelBody": "Betalingsaftalen opsiges hos betalingsløsningen, og der sendes ikke mere.",
    "cancelConfirm": "Annullér abonnementet",
    "copyCustomerLink": "Kopiér kundelink",
    "failedTimes": "Betalingen fejlede {count} gange.",
    "parkedBody": "Abonnementet er sat i bero — det er ikke annulleret, så kunden kan fortsætte med et nyt kort.",
    "newAgreement": "Registrér ny betalingsaftale",
    "cardExpiredBody": "Betalingskortet udløb {expiry}. Næste træk vil fejle.",
    "updateCard": "Opdatér kort",
    "freeStock": "{count} fri på lager",
    "unknownProduct": "Varen findes ikke i kataloget længere — trækket vil fejle.",
    "units": "{count} stk.",
    "interval": "Interval",
    "rhythm": "Rytme",
    "started": "Startet",
    "editAgreement": "Redigér betalingsaftale",
    "editTitle": "Redigér abonnement",
    "intervalMonths": "Interval (måneder)",
    "zeroRemoves": "Sæt til 0 for at fjerne varen fra abonnementet.",
    "agreementHelp": "Registrér den aftale betalingsløsningen har givet for kundens kort. Et abonnement i bero bliver aktivt igen med det samme.",
    "expiryMonth": "Udløbsmåned",
    "expiryYear": "Udløbsår",
    "back": "Tilbage til abonnementer",
    "skip": "Spring over",
    "agreementTitle": "Betalingsaftale"
  },
  "translations": {
    "title": "Egne ord",
    "intro": "Skriv jeres egne ord for enkelte tekster. Alt I ikke ændrer, følger med opdateringerne.",
    "key": "Nøgle",
    "value": "Jeres tekst",
    "default": "Standard",
    "changedSince": "Standardteksten er ændret siden I skrev jeres egen.",
    "saved": "Teksten er gemt",
    "removed": "Jeres tekst er fjernet",
    "empty": "I bruger standardteksterne overalt.",
    "errors": {
      "localeUnsupported": "Sproget understøttes ikke.",
      "valueRequired": "Skriv en tekst."
    },
    "loadFailed": "Kunne ikke hente jeres tekster.",
    "searchPlaceholder": "Søg i nøgle eller tekst",
    "onlyMine": "Kun det I har ændret",
    "changedCount": "{count} ændret",
    "noMatches": "Ingen tekster matcher søgningen.",
    "editTitle": "Skriv jeres egen tekst",
    "reset": "Nulstil",
    "resetTitle": "Tilbage til standardteksten",
    "resetBody": "Jeres egen tekst slettes, og teksten følger igen med opdateringerne.",
    "removeFailed": "Kunne ikke fjerne jeres tekst",
    "placeholderHint": "Krøllede parenteser som {'{'}name{'}'} er værdier, teksten får udefra. Beholder I dem ikke, mangler tallet eller navnet i den færdige sætning."
  },
  "auth": {
    "errors": {
      "linkNoLongerValid": "Linket virker ikke længere. Bed om et nyt.",
      "resetFailed": "Adgangskoden kunne ikke skiftes.",
      "passwordTooShort": "Adgangskoden skal være mindst {length} tegn.",
      "passwordRequiresDigit": "Adgangskoden skal indeholde mindst ét tal.",
      "passwordRequiresLower": "Adgangskoden skal indeholde mindst ét lille bogstav.",
      "passwordRequiresUpper": "Adgangskoden skal indeholde mindst ét stort bogstav.",
      "passwordRequiresSymbol": "Adgangskoden skal indeholde mindst ét tegn, der hverken er bogstav eller tal.",
      "passwordRequiresUniqueChars": "Adgangskoden skal indeholde mindst {count} forskellige tegn.",
      "emailNotConfirmed": "Bekræft din e-mailadresse, før du logger ind.",
      "codeInvalid": "Koden passer ikke, eller den er for gammel. Bed om en ny.",
      "codeNotSent": "Koden kunne ikke sendes. Prøv at bede om en ny.",
      "twoFactorExpired": "Login-forsøget er udløbet. Start forfra.",
      "confirmBeforeTwoFactor": "Bekræft din e-mailadresse, før du slår koden til — den skal jo sendes et sted hen."
    }
  },
  "forgotPassword": {
    "title": "Glemt adgangskode",
    "subtitle": "Vi sender et link, du kan vælge en ny med.",
    "submit": "Send link",
    "sentTitle": "Så er den sendt",
    "sentBody": "Findes der en konto på {email}, ligger linket i indbakken om et øjeblik. Kig også i spamfilteret.",
    "backToLogin": "Tilbage til login"
  },
  "resetPassword": {
    "title": "Vælg en ny adgangskode",
    "subtitle": "Den gamle holder op med at virke, så snart du har gemt.",
    "newPassword": "Ny adgangskode",
    "repeatPassword": "Gentag adgangskoden",
    "mismatch": "De to adgangskoder er ikke ens.",
    "submit": "Gem adgangskode",
    "doneTitle": "Adgangskoden er skiftet",
    "doneBody": "Du er logget ud alle steder. Log ind med den nye.",
    "signIn": "Log ind"
  },
  "confirmEmail": {
    "title": "Bekræft din e-mailadresse",
    "lead": "Tryk på knappen for at bekræfte, at denne adresse er din.",
    "confirmButton": "Bekræft adressen",
    "doneTitle": "Tak — adressen er bekræftet",
    "doneBody": "Du kan logge ind som sædvanlig.",
    "signIn": "Log ind"
  },
  "carriers": {
    "title": "Fragtaftaler",
    "subtitle": "Kontoen labels bookes på. Der bookes ingen pakker herfra.",
    "add": "Tilslut en konto",
    "addTitle": "Tilslut en fragtkonto",
    "editTitle": "Redigér fragtkonto",
    "empty": "Der er ingen fragtkonti endnu.",
    "loadFailed": "Kunne ikke hente fragtkonti.",
    "saveFailed": "Kunne ikke gemme fragtkontoen.",
    "testFailed": "Forbindelsen kunne ikke afprøves.",
    "test": "Afprøv",
    "testModeOn": "Testtilstand",
    "notConfigured": "Mangler opsætning",
    "productsFound": "Fragtprodukter, kontoen kan bruge:",
    "name": "Navn",
    "key": "Nøgle",
    "keyHint": "Udledes automatisk. Det er denne værdi, en fragtregel skriver i feltet Fragtfirma.",
    "apiUser": "API-bruger",
    "apiKey": "API-nøgle",
    "secretHint": "Udfyldes kun for at erstatte. Lades feltet tomt, beholdes den gemte.",
    "baseUrl": "API-adresse",
    "baseUrlHint": "Tom betyder produktion. Sandkassen ligger på et andet domæne.",
    "senderCompany": "Afsender",
    "senderHint": "Adressen pakken sendes fra. Står på labelen.",
    "senderStreet": "Vej og nummer",
    "senderPostalCode": "Postnr.",
    "senderCity": "By",
    "senderCountry": "Land",
    "useOwnAgreement": "Book på vores egen fragtaftale",
    "testMode": "Testtilstand — der bookes ingen rigtige pakker",
    "testModeOffWarning": "Med testtilstand slået fra bliver næste forsendelse en rigtig pakke på en rigtig faktura.",
    "advanced": "Avanceret"
  },
  "invitation": {
    "title": "Vælg din adgangskode",
    "subtitle": "Så er du klar til at logge ind.",
    "choosePassword": "Adgangskode",
    "submit": "Gem og fortsæt",
    "doneTitle": "Så er du klar",
    "doneBody": "Din adgangskode er sat, og din e-mailadresse er bekræftet. Log ind for at komme i gang."
  },
  "twoFactor": {
    "title": "Tjek din mail",
    "sentTo": "Vi har sendt en kode til {email}.",
    "code": "Kode",
    "submit": "Fortsæt",
    "resend": "Send en ny kode",
    "resent": "Sendt. Kig i din indbakke — og i spamfilteret.",
    "rememberBrowser": "Spørg ikke igen på denne computer",
    "back": "Tilbage til login"
  },
  "productImages": {
    "title": "Billeder hentes hjem",
    "subtitle": "Produktbillederne peger stadig på den gamle shops servere. De virker, indtil shoppen lukkes ned — derfor hentes de hjem, så smibo ejer kataloget frem for at låne det.",
    "counts": "{stored} af {total} hentet · {remaining} tilbage",
    "failed": "{count} kunne ikke hentes",
    "fetch": "Hent billeder hjem",
    "stop": "Stop",
    "retryFailed": "Prøv de fejlede igen",
    "includeDead": "Tag de {count} billeder med, der hører til varer uden lager, uden aktivering og uden salg",
    "allHeld": "Alle billeder ligger nu hos os."
  }
}
